/**
 * Dimensions and facts derived from the two Jupiterol extracts in
 * src/assets/EMD_data (852 inventory, 867 sales). Generated — do not hand-edit;
 * regenerate if the extracts change.
 *
 * Facts are numeric tuples with dimension indices rather than objects with
 * repeated string keys, which keeps 3629 rows small enough to ship as source.
 *
 * Coverage: 2025-04-04 .. 2026-03-27
 *           36538 867 rows and 14981 852 rows collapsed to weekly buckets.
 */

/** Product is single-NDC in both extracts. */
export const PRODUCT = { brand: 'JUPITEROL', ndc: '77778888999', uom: 'EACH' };

/** Week-ending (Saturday) dates, oldest first. Fact tuples index into this. */
export const WEEKS: string[] = [
  '2025-04-04', '2025-04-11', '2025-04-18', '2025-04-25', '2025-05-02', '2025-05-09', '2025-05-16', '2025-05-23', '2025-05-30', '2025-06-06', '2025-06-13', '2025-06-20', '2025-06-27', '2025-07-04', '2025-07-11', '2025-07-18', '2025-07-25', '2025-08-01', '2025-08-08', '2025-08-15', '2025-08-22', '2025-08-29', '2025-09-05', '2025-09-12', '2025-09-19', '2025-09-26', '2025-10-03', '2025-10-10', '2025-10-17', '2025-10-24', '2025-10-31', '2025-11-07', '2025-11-14', '2025-11-21', '2025-11-28', '2025-12-05', '2025-12-12', '2025-12-19', '2025-12-26', '2026-01-02', '2026-01-09', '2026-01-16', '2026-01-23', '2026-01-30', '2026-02-06', '2026-02-13', '2026-02-20', '2026-02-27', '2026-03-06', '2026-03-13', '2026-03-20', '2026-03-27',
];

export interface EmdWholesaler { name: string; color: string; }
export const WHOLESALERS: EmdWholesaler[] = [
  {"name":"ASD Specialty","color":"#7B68EE"},
  {"name":"McKesson Plasma & Biologics","color":"#2EC4B6"},
  {"name":"Cardinal Specialty","color":"#43C678"},
  {"name":"McKesson Specialty (OTN)","color":"#1E90FF"},
  {"name":"Oncology Supply","color":"#F4A340"},
  {"name":"Cardinal Health","color":"#B57BEA"},
  {"name":"BioCare","color":"#FF7043"},
];

export interface EmdDc { name: string; ws: number; city: string; state: string; region: string; }
export const DCS: EmdDc[] = [
  {"name":"Cardinal Health-Syracuse","ws":5,"city":"Syracuse","state":"NY","region":"Northeast"},
  {"name":"Oncology Supply Co. - Montclair, CA","ws":4,"city":"Montclair","state":"CA","region":"West"},
  {"name":"ASD - Montclair, CA","ws":0,"city":"Montclair","state":"CA","region":"West"},
  {"name":"Oncology Supply Co.","ws":4,"city":"Dothan","state":"AL","region":"Southeast"},
  {"name":"ASD - Dothan, AL","ws":0,"city":"Dothan","state":"AL","region":"Southeast"},
  {"name":"ASD Healthcare - Brooks 1","ws":0,"city":"Brooks","state":"KY","region":"Southeast"},
  {"name":"Cardinal Health Spec-La Vergne 800","ws":2,"city":"La Vergne","state":"TN","region":"Southeast"},
  {"name":"McKesson Plasma & Biologics - Memphis","ws":1,"city":"Memphis","state":"TN","region":"Southeast"},
  {"name":"ASD Specialty Healthcare, Inc. - Trademark Drive","ws":0,"city":"Reno","state":"NV","region":"Mountain"},
  {"name":"McKesson Specialty Distribution Corporation","ws":3,"city":"Memphis","state":"TN","region":"Southeast"},
  {"name":"McKesson Specialty Care","ws":3,"city":"La Vergne","state":"TN","region":"Southeast"},
  {"name":"Cardinal Health - Guaynabo","ws":5,"city":"Guaynabo","state":"PR","region":"Southeast"},
  {"name":"McKesson Plasma & Biologics - Shepherdsville, KY","ws":1,"city":"Shepherdsville","state":"KY","region":"Southeast"},
  {"name":"McKesson Specialty - Shepherdsville, KY","ws":3,"city":"Shepherdsville","state":"KY","region":"Southeast"},
  {"name":"McKesson Plasma and Biologics - Olive Branch MS","ws":1,"city":"Olive Branch","state":"MS","region":"Southeast"},
  {"name":"BioCare Olive Branch","ws":6,"city":"Olive Branch","state":"MS","region":"Southeast"},
  {"name":"BioCare","ws":6,"city":"Tempe","state":"AZ","region":"Mountain"},
  {"name":"McKesson Specialty Distribution - Olive Branch MS","ws":3,"city":"Olive Branch","state":"MS","region":"Southeast"},
];

export interface EmdCustomer { name: string; cot: string; city: string; state: string; region: string; }
export const CUSTOMERS: EmdCustomer[] = [
  {"name":"City of Hope Duarte OPD","cot":"Oncology Clinic","city":"Duarte","state":"CA","region":"West"},
  {"name":"MSKCC Specialty RX","cot":"Specialty Pharmacies","city":"New York","state":"NY","region":"Northeast"},
  {"name":"The Univ of Kansas Health System Southlake","cot":"Teaching Hospitals","city":"Lenexa","state":"KS","region":"Midwest"},
  {"name":"The Ohio State University Outpatient Pharmacy","cot":"Retail Pharmacies","city":"Columbus","state":"OH","region":"Midwest"},
  {"name":"RR UCLAMC MP1 RTL 340B","cot":"Retail Pharmacies","city":"Los Angeles","state":"CA","region":"West"},
  {"name":"Penn Medicine 76th Street Pharmacy","cot":"Specialty Pharmacies","city":"Philadelphia","state":"PA","region":"Northeast"},
  {"name":"Northwestern Memorial Physicia","cot":"Clinic/ Group Practice","city":"Chicago","state":"IL","region":"Midwest"},
  {"name":"VUMC NA CL VIP GPO","cot":"Clinic/ Group Practice","city":"Nashville","state":"TN","region":"Southeast"},
  {"name":"Mayo Clinic Pharmacy 340B ST","cot":"Retail Pharmacies","city":"Rochester","state":"MN","region":"Midwest"},
  {"name":"Moffitt Outpatient Chemotherapy Pharmac","cot":"Specialty Pharmacies","city":"Tampa","state":"FL","region":"Southeast"},
  {"name":"Cleveland Clinic Specialty/Home Delivery","cot":"Specialty Pharmacies","city":"Beachwood","state":"OH","region":"Midwest"},
  {"name":"MUSC Consolidated Services Center","cot":"Distributors","city":"North Charleston","state":"SC","region":"Southeast"},
  {"name":"Mount Sinai Specialty Pharmacy","cot":"Specialty Pharmacies","city":"New York","state":"NY","region":"Northeast"},
  {"name":"IU HLTH Adv Therapies WAC","cot":"Home HealthCare Provider w/Retail","city":"Plainfield","state":"IN","region":"Midwest"},
  {"name":"UCSF OPD- WAC","cot":"Clinic/ Group Practice","city":"San Francisco","state":"CA","region":"West"},
  {"name":"Roswell Park Cancer Institute Pharmacy","cot":"Specialty Pharmacies","city":"Buffalo","state":"NY","region":"Northeast"},
  {"name":"Dana Farber Cancer Institute","cot":"Oncology Clinic","city":"Boston","state":"MA","region":"Northeast"},
  {"name":"Froedtert Health Comm PHYS Clinic","cot":"Clinic/ Group Practice","city":"Menomonee Falls","state":"WI","region":"Midwest"},
  {"name":"Emory Univ Hosp Midtown Inpatient Pharmacy","cot":"Non-Retail Pharmacy","city":"Atlanta","state":"GA","region":"Southeast"},
  {"name":"Texas Oncology Pharmacy Medical City","cot":"Specialty Pharmacies","city":"Dallas","state":"TX","region":"Southwest"},
  {"name":"University of Texas MD Anderson Cancer Center","cot":"Oncology Clinic","city":"Houston","state":"TX","region":"Southwest"},
  {"name":"Northside Hospital Pharmacy @ Medical Tower","cot":"Retail Pharmacies","city":"Atlanta","state":"GA","region":"Southeast"},
  {"name":"Oregon State University CHH Pharmacy 2","cot":"Retail Pharmacies","city":"Portland","state":"OR","region":"West"},
  {"name":"University of Utah Outpatient Pharmacy","cot":"Retail Pharmacies","city":"Salt Lake City","state":"UT","region":"Mountain"},
  {"name":"FRVW PHCY Long Term Care","cot":"Retail Pharmacy Chain","city":"Minneapolis","state":"MN","region":"Midwest"},
  {"name":"UAB Specialty Pharmacy","cot":"Specialty Pharmacies","city":"Birmingham","state":"AL","region":"Southeast"},
  {"name":"ONCO360 LSV/STFRNMSKG PHS","cot":"Specialty Pharmacies","city":"Louisville","state":"KY","region":"Southeast"},
  {"name":"Strong Memorial Hospital","cot":"Hospital","city":"Rochester","state":"NY","region":"Northeast"},
  {"name":"OU HLTH Stephenson Can CTR PHY WAC","cot":"Non-Retail Pharmacy","city":"Oklahoma City","state":"OK","region":"Southwest"},
  {"name":"MUSC Mail Order Pharmacy","cot":"Mail Order - Contract Only","city":"Charleston","state":"SC","region":"Southeast"},
  {"name":"Mskcc-Specialty Pharmacy Mid","cot":"Specialty Pharmacies","city":"Long Island City","state":"NY","region":"Northeast"},
  {"name":"Ucmc Specialty PCY PHS","cot":"Specialty Pharmacies","city":"Calumet City","state":"IL","region":"Midwest"},
  {"name":"University of Colorado Hospital","cot":"Teaching Hospitals","city":"Aurora","state":"CO","region":"Mountain"},
  {"name":"Temple HLTH SPLTY Pharm","cot":"Specialty Pharmacies","city":"Philadelphia","state":"PA","region":"Northeast"},
  {"name":"Oncology Hematology Care-Orals","cot":"Oncology Clinic","city":"Blue Ash","state":"OH","region":"Midwest"},
  {"name":"Hup-Perelman Pharmacy","cot":"Non-Retail Pharmacy","city":"Philadelphia","state":"PA","region":"Northeast"},
  {"name":"Penn ST MS Hershey Med Op","cot":"Clinic/ Group Practice","city":"Hershey","state":"PA","region":"Northeast"},
  {"name":"Walnut Hme Therapeutic 2","cot":"Home HealthCare Provider w/Retail","city":"King Of Prussia","state":"PA","region":"Northeast"},
  {"name":"Blinded","cot":"Blinded","city":"Lawrenceville","state":"GA","region":"Southeast"},
  {"name":"MUSC Mail Order PHCY PHS","cot":"Mail Order - Contract Only","city":"Charleston","state":"SC","region":"Southeast"},
  {"name":"Biologics BY McKesson","cot":"Specialty Pharmacies","city":"Cary","state":"NC","region":"Southeast"},
  {"name":"Fairview Infusion Services Pharmacy","cot":"Specialty Pharmacies","city":"Minneapolis","state":"MN","region":"Midwest"},
  {"name":"Jhop 03 Wein JHH PHS","cot":"Specialty Pharmacies","city":"Baltimore","state":"MD","region":"Southeast"},
  {"name":"Texas Oncology Pharmacy","cot":"Specialty Pharmacies","city":"Waco","state":"TX","region":"Southwest"},
  {"name":"Montefiore Hospital and Medical CTR","cot":"Teaching Hospitals","city":"Bronx","state":"NY","region":"Northeast"},
  {"name":"Fred Hutchinson Cancer Center","cot":"Oncology Clinic","city":"Seattle","state":"WA","region":"West"},
  {"name":"UK Specialty Pharmacy 340B","cot":"Specialty Pharmacies","city":"Lexington","state":"KY","region":"Southeast"},
  {"name":"Loyola Outpatient CTR","cot":"Clinic/ Group Practice","city":"Maywood","state":"IL","region":"Midwest"},
  {"name":"University Hospitals Home Care Services","cot":"Home HealthCare Provider w/Retail","city":"Warrensville Heights","state":"OH","region":"Midwest"},
  {"name":"Duke Uh CC Specialty PHCY WAC","cot":"Specialty Pharmacies","city":"Durham","state":"NC","region":"Southeast"},
  {"name":"UAMS Outpatient Pharmacy","cot":"Retail Pharmacies","city":"Little Rock","state":"AR","region":"Southwest"},
  {"name":"Fox Chase Cancer Center Pharmacy","cot":"Specialty Pharmacies","city":"Philadelphia","state":"PA","region":"Northeast"},
  {"name":"Upmc Chartwell","cot":"Home HealthCare Provider w/Retail","city":"Oakdale","state":"PA","region":"Northeast"},
  {"name":"Karmanos/Karmanos CNC PHS","cot":"Oncology Clinic","city":"Troy","state":"MI","region":"Midwest"},
  {"name":"University of Mi Medical CTR","cot":"Teaching Hospitals","city":"Ann Arbor","state":"MI","region":"Midwest"},
  {"name":"MUSC Hollings Cancer Center Pharmacy","cot":"Specialty Pharmacies","city":"Charleston","state":"SC","region":"Southeast"},
  {"name":"Rochester Hills Pharmacy","cot":"Retail Pharmacies","city":"Orlando","state":"FL","region":"Southeast"},
  {"name":"University of Louisville Hospital","cot":"Teaching Hospitals","city":"Louisville","state":"KY","region":"Southeast"},
  {"name":"Univ of Miami Specialty Pharmacy","cot":"Specialty Pharmacies","city":"Medley","state":"FL","region":"Southeast"},
  {"name":"Vcuhs Now PHCY 340B ST","cot":"Non-Retail Pharmacy","city":"Richmond","state":"VA","region":"Southeast"},
  {"name":"Duke N Paviln Ret PHCY WAC ST","cot":"Retail Pharmacies","city":"Durham","state":"NC","region":"Southeast"},
  {"name":"Lumicera HLTH SRVCS LLC RX","cot":"Specialty Pharmacies","city":"Madison","state":"WI","region":"Midwest"},
  {"name":"Froedtert Pharmacy 025","cot":"Non-Retail Pharmacy","city":"Milwaukee","state":"WI","region":"Midwest"},
  {"name":"LS Packard Children Op","cot":"Clinic/ Group Practice","city":"Palo Alto","state":"CA","region":"West"},
  {"name":"Ohsu Creekside Pharmacy","cot":"Retail Pharmacies","city":"Beaverton","state":"OR","region":"West"},
  {"name":"Johns Hopkins Central Fill Pharmacy","cot":"Non-Retail Pharmacy","city":"Baltimore","state":"MD","region":"Southeast"},
  {"name":"Ah Pharmacy Kenilwrth/Cmc PHS","cot":"Retail Pharmacies","city":"Charlotte","state":"NC","region":"Southeast"},
  {"name":"Blind","cot":"Blinded","city":"Renton","state":"WA","region":"West"},
  {"name":"Emory Specialty Pharmacy","cot":"Specialty Pharmacies","city":"Atlanta","state":"GA","region":"Southeast"},
  {"name":"Unc HLTH Speclty Home Delv PHY","cot":"Home HealthCare Provider w/Retail","city":"Morrisville","state":"NC","region":"Southeast"},
  {"name":"Nyu Langone Hospitals","cot":"Specialty Pharmacies","city":"Brooklyn","state":"NY","region":"Northeast"},
  {"name":"UAMS Med Center Bdi MPB","cot":"College and Universities","city":"Little Rock","state":"AR","region":"Southwest"},
  {"name":"Tulane Pharmacy","cot":"Retail Pharmacies","city":"New Orleans","state":"LA","region":"Southwest"},
  {"name":"Uchealth Centralized Pharmacy","cot":"Non-Retail Pharmacy","city":"Aurora","state":"CO","region":"Mountain"},
  {"name":"IU Health Inc Uh Univ Hosp","cot":"Teaching Hospitals","city":"Indianapolis","state":"IN","region":"Midwest"},
  {"name":"RWJBH Isp 340B","cot":"Specialty Pharmacies","city":"South Plainfield","state":"NJ","region":"Northeast"},
  {"name":"Indiana University Health Inc","cot":"College and Universities","city":"Indianapolis","state":"IN","region":"Midwest"},
  {"name":"Nebraska Medicine Hub Pharmacy","cot":"Retail Pharmacies","city":"Omaha","state":"NE","region":"Midwest"},
  {"name":"Fred Hutchinson Cancer CTR Clinic","cot":"Oncology Clinic","city":"Seattle","state":"WA","region":"West"},
  {"name":"Texas Oncology Pharmacy - Flower Mound","cot":"Specialty Pharmacies","city":"Flower Mound","state":"TX","region":"Southwest"},
  {"name":"Tennessee Oncology - Park Pharmacy","cot":"Specialty Pharmacies","city":"Nashville","state":"TN","region":"Southeast"},
  {"name":"NWMS Pharmacy","cot":"Specialty Pharmacies","city":"Niles","state":"IL","region":"Midwest"},
  {"name":"Ut Southwestern Med Center Pharmacy","cot":"Specialty Pharmacies","city":"Dallas","state":"TX","region":"Southwest"},
  {"name":"Illinois Cancer Specialists-Niles","cot":"Oncology Clinic","city":"Niles","state":"IL","region":"Midwest"},
  {"name":"JKW Medical Group PLLC","cot":"Clinic/ Group Practice","city":"Bellevue","state":"WA","region":"West"},
  {"name":"West Clinic Pharmacy","cot":"Specialty Pharmacies","city":"Germantown","state":"TN","region":"Southeast"},
  {"name":"Texas Oncology-Phmcy-Denison","cot":"Specialty Pharmacies","city":"Denison","state":"TX","region":"Southwest"},
  {"name":"Simmons Cancer Center Pharmacy","cot":"Specialty Pharmacies","city":"Dallas","state":"TX","region":"Southwest"},
  {"name":"Texas Oncology Fort Worth","cot":"Oncology Clinic","city":"Fort Worth","state":"TX","region":"Southwest"},
  {"name":"Texas Oncology and Hematology","cot":"Oncology Clinic","city":"Dallas","state":"TX","region":"Southwest"},
  {"name":"Virginia Cancer Specialists Fairf","cot":"Oncology Clinic","city":"Fairfax","state":"VA","region":"Southeast"},
  {"name":"Mercy Health Pharmacy-Mid","cot":"Retail Pharmacies","city":"Maryland Heights","state":"MO","region":"Midwest"},
  {"name":"Tnonc- Midtown Pharmacy","cot":"Specialty Pharmacies","city":"Nashville","state":"TN","region":"Southeast"},
  {"name":"Compassionate Cancer Care-Fountain","cot":"Oncology Clinic","city":"Fountain Valley","state":"CA","region":"West"},
  {"name":"Texas Onc Pharmacy","cot":"Specialty Pharmacies","city":"Fort Worth","state":"TX","region":"Southwest"},
  {"name":"Texas Oncology-Tyler","cot":"Specialty Pharmacies","city":"Tyler","state":"TX","region":"Southwest"},
  {"name":"Texas Oncology-Phmcy-Denton","cot":"Specialty Pharmacies","city":"Denton","state":"TX","region":"Southwest"},
  {"name":"Washington Univ Renal Div West Co","cot":"Clinic/ Group Practice","city":"Creve Coeur","state":"MO","region":"Midwest"},
  {"name":"Highlands Oncology Group Pa","cot":"Oncology Clinic","city":"Rogers","state":"AR","region":"Southwest"},
  {"name":"New York Oncology Hematology PC","cot":"Oncology Clinic","city":"Albany","state":"NY","region":"Northeast"},
  {"name":"Texas Oncology Pharmacy Rockwall","cot":"Specialty Pharmacies","city":"Rockwall","state":"TX","region":"Southwest"},
  {"name":"Cancer Center of Kansas Pa","cot":"Oncology Clinic","city":"Wichita","state":"KS","region":"Midwest"},
  {"name":"Los Angeles Hem Onc Med Group","cot":"Oncology Clinic","city":"Glendale","state":"CA","region":"West"},
  {"name":"Manhattan Advanced Care-Os","cot":"Oncology Clinic","city":"New York","state":"NY","region":"Northeast"},
  {"name":"Texas Oncology Phcy-Amarillo","cot":"Specialty Pharmacies","city":"Amarillo","state":"TX","region":"Southwest"},
  {"name":"Bridgepointe Physician Group","cot":"Clinic/ Group Practice","city":"Mountain View","state":"CA","region":"West"},
  {"name":"TX Onc PHMCY-S Arlington","cot":"Specialty Pharmacies","city":"Mansfield","state":"TX","region":"Southwest"},
  {"name":"Texas Oncology-Keller","cot":"Oncology Clinic","city":"Fort Worth","state":"TX","region":"Southwest"},
  {"name":"Michaela G Scott MD and Associates","cot":"Clinic/ Group Practice","city":"Vero Beach","state":"FL","region":"Southeast"},
];

export const CLASSES_OF_TRADE: string[] = ["Blinded","Clinic/ Group Practice","College and Universities","Distributors","Home HealthCare Provider w/Retail","Hospital","Mail Order - Contract Only","Non-Retail Pharmacy","Oncology Clinic","Retail Pharmacies","Retail Pharmacy Chain","Specialty Pharmacies","Teaching Hospitals"];
export const REGIONS: string[] = ["Midwest","Mountain","Northeast","Southeast","Southwest","West"];
export const STATES: string[] = ["AL","AR","AZ","CA","CO","FL","GA","IL","IN","KS","KY","LA","MA","MD","MI","MN","MO","MS","NC","NE","NJ","NV","NY","OH","OK","OR","PA","PR","SC","TN","TX","UT","VA","WA","WI"];

/** [weekIdx, wholesalerIdx, customerIdx, qty, dollars, returnQty] */
export type EmdSalesFact = [number, number, number, number, number, number];
export const SALES_FACTS: EmdSalesFact[] = [
  [0,0,0,15,274021,0],
  [0,0,4,14,255753,0],
  [0,0,6,5,91340,0],
  [0,0,9,18,328825,0],
  [0,0,10,6,109608,0],
  [0,0,12,5,91340,0],
  [0,0,14,11,200949,0],
  [0,0,16,7,127877,0],
  [0,0,17,4,73072,0],
  [0,0,20,5,91340,0],
  [0,0,21,1,18268,0],
  [0,0,26,5,91340,0],
  [0,0,28,4,73072,0],
  [0,0,38,26,474970,0],
  [0,0,53,4,73072,0],
  [0,0,54,2,36536,0],
  [0,0,56,3,54804,0],
  [0,0,62,2,36536,1],
  [0,0,67,3,54804,0],
  [0,0,69,1,18268,0],
  [0,0,70,4,73072,0],
  [0,0,84,1,18268,0],
  [0,1,1,18,328825,0],
  [0,1,5,19,347094,0],
  [0,1,7,16,292289,0],
  [0,1,11,28,511506,0],
  [0,1,15,3,54804,0],
  [0,1,18,9,164413,0],
  [0,1,24,2,36536,0],
  [0,1,25,3,54804,0],
  [0,1,26,1,18268,0],
  [0,1,31,7,127877,0],
  [0,1,33,5,91340,0],
  [0,1,40,1,18268,0],
  [0,1,41,2,36536,0],
  [0,1,48,3,54804,0],
  [0,1,51,6,109608,0],
  [0,1,55,2,36536,0],
  [0,1,63,2,36536,0],
  [0,1,65,4,73072,0],
  [0,2,2,10,182681,0],
  [0,2,3,9,164413,0],
  [0,2,8,9,164413,0],
  [0,2,13,7,127877,0],
  [0,2,22,1,18268,0],
  [0,2,27,7,127877,0],
  [0,2,32,1,18268,0],
  [0,2,44,1,18268,0],
  [0,2,46,4,73072,0],
  [0,2,49,4,73072,0],
  [0,2,50,3,54804,0],
  [0,2,52,1,18268,0],
  [0,2,64,4,73072,0],
  [0,2,73,3,54804,0],
  [0,3,43,1,18268,0],
  [0,4,80,2,36536,0],
  [1,0,0,27,493238,0],
  [1,0,4,18,328825,0],
  [1,0,6,10,182681,0],
  [1,0,9,2,36536,0],
  [1,0,10,12,219217,0],
  [1,0,12,7,127877,0],
  [1,0,14,5,91340,0],
  [1,0,16,6,109608,0],
  [1,0,17,6,109608,0],
  [1,0,20,3,54804,0],
  [1,0,21,8,146145,0],
  [1,0,26,2,36536,0],
  [1,0,28,11,200949,0],
  [1,0,36,9,164413,0],
  [1,0,37,14,255753,0],
  [1,0,38,10,182681,1],
  [1,0,47,2,36536,0],
  [1,0,53,3,54804,0],
  [1,0,56,5,91340,0],
  [1,0,62,2,36536,0],
  [1,0,69,2,36536,0],
  [1,0,84,1,18268,0],
  [1,0,93,1,18268,0],
  [1,1,1,4,73072,0],
  [1,1,5,13,237485,0],
  [1,1,7,7,127877,0],
  [1,1,15,4,73072,0],
  [1,1,18,9,164413,0],
  [1,1,23,5,91340,0],
  [1,1,24,3,54804,0],
  [1,1,25,6,109608,0],
  [1,1,33,3,54804,0],
  [1,1,51,3,54804,0],
  [1,1,55,1,18268,0],
  [1,1,63,1,18268,0],
  [1,2,2,26,474970,0],
  [1,2,3,7,127877,0],
  [1,2,8,14,255753,0],
  [1,2,13,14,255753,0],
  [1,2,22,4,73072,0],
  [1,2,27,4,73072,0],
  [1,2,44,1,18268,0],
  [1,2,46,1,18268,0],
  [1,2,49,3,54804,0],
  [1,2,50,4,73072,0],
  [1,2,58,3,54804,0],
  [1,2,59,1,18268,0],
  [1,2,60,6,109608,0],
  [1,2,64,3,54804,0],
  [1,2,73,2,36536,0],
  [1,2,75,6,109608,0],
  [1,2,77,3,54804,0],
  [1,3,19,6,109608,0],
  [1,3,34,2,36536,0],
  [1,3,43,3,54804,0],
  [1,3,45,5,91340,0],
  [1,3,91,1,18268,0],
  [1,4,80,1,18268,0],
  [2,0,0,24,438434,0],
  [2,0,4,11,200949,0],
  [2,0,6,16,292289,0],
  [2,0,9,8,146145,0],
  [2,0,10,9,164413,0],
  [2,0,12,7,127877,0],
  [2,0,14,3,54804,0],
  [2,0,16,6,109608,0],
  [2,0,17,7,127877,0],
  [2,0,20,5,91340,0],
  [2,0,21,5,91340,0],
  [2,0,28,6,109608,0],
  [2,0,36,3,54804,0],
  [2,0,38,17,310557,0],
  [2,0,47,2,36536,0],
  [2,0,53,3,54804,0],
  [2,0,54,2,36536,0],
  [2,0,56,5,91340,0],
  [2,0,67,3,54804,0],
  [2,0,69,5,91340,0],
  [2,0,70,1,18268,0],
  [2,1,1,22,401898,0],
  [2,1,5,11,200949,0],
  [2,1,7,10,182681,0],
  [2,1,15,9,164413,0],
  [2,1,18,4,73072,0],
  [2,1,24,3,54804,0],
  [2,1,25,6,109608,0],
  [2,1,31,3,54804,0],
  [2,1,33,7,127877,0],
  [2,1,40,1,18268,0],
  [2,1,41,1,18268,0],
  [2,1,48,5,91340,0],
  [2,1,51,6,109608,0],
  [2,1,63,2,36536,0],
  [2,1,65,4,73072,0],
  [2,2,2,12,219217,0],
  [2,2,3,24,438434,0],
  [2,2,13,11,200949,0],
  [2,2,22,5,91340,0],
  [2,2,26,2,36536,0],
  [2,2,27,4,73072,0],
  [2,2,40,8,146145,0],
  [2,2,44,7,127877,0],
  [2,2,46,2,36536,0],
  [2,2,49,3,54804,0],
  [2,2,50,1,18268,0],
  [2,2,52,3,54804,0],
  [2,2,59,2,36536,0],
  [2,2,73,3,54804,0],
  [2,3,19,10,182681,0],
  [2,3,34,1,18268,0],
  [2,3,79,2,36536,0],
  [2,3,86,1,18268,0],
  [3,0,4,3,54804,0],
  [3,0,6,7,127877,0],
  [3,0,9,4,73072,0],
  [3,0,10,5,91340,0],
  [3,0,14,12,219217,0],
  [3,0,17,8,146145,0],
  [3,0,20,5,91340,0],
  [3,0,21,4,73072,0],
  [3,0,28,4,73072,0],
  [3,0,38,16,292289,1],
  [3,0,47,4,73072,0],
  [3,0,53,1,18268,0],
  [3,0,56,2,36536,0],
  [3,0,62,2,36536,0],
  [3,0,67,2,36536,0],
  [3,0,69,6,109608,0],
  [3,0,72,1,18268,0],
  [3,1,1,12,219217,0],
  [3,1,5,7,127877,0],
  [3,1,7,10,182681,0],
  [3,1,11,4,73072,0],
  [3,1,15,3,54804,0],
  [3,1,18,4,73072,0],
  [3,1,23,4,73072,0],
  [3,1,24,3,54804,0],
  [3,1,25,1,18268,0],
  [3,1,31,3,54804,0],
  [3,1,33,7,127877,0],
  [3,1,40,1,18268,0],
  [3,1,41,3,54804,0],
  [3,1,48,1,18268,0],
  [3,1,51,1,18268,0],
  [3,1,63,3,54804,0],
  [3,1,65,3,54804,0],
  [3,2,2,20,365362,0],
  [3,2,3,10,182681,0],
  [3,2,8,12,219217,0],
  [3,2,13,8,146145,0],
  [3,2,22,5,91340,0],
  [3,2,26,1,18268,0],
  [3,2,32,3,54804,0],
  [3,2,44,2,36536,0],
  [3,2,46,8,146145,0],
  [3,2,49,4,73072,0],
  [3,2,50,2,36536,0],
  [3,2,57,3,54804,0],
  [3,2,59,1,18268,0],
  [3,2,61,3,54804,0],
  [3,2,73,2,36536,0],
  [3,2,75,3,54804,0],
  [3,2,77,3,54804,0],
  [3,3,19,15,274021,0],
  [3,3,34,4,73072,0],
  [3,3,43,4,73072,0],
  [3,3,45,5,91340,0],
  [4,0,0,34,621115,0],
  [4,0,4,8,146145,0],
  [4,0,6,8,146145,0],
  [4,0,9,15,274021,0],
  [4,0,10,6,109608,0],
  [4,0,12,6,109608,0],
  [4,0,16,8,146145,0],
  [4,0,17,2,36536,0],
  [4,0,20,8,146145,0],
  [4,0,21,9,164413,0],
  [4,0,28,6,109608,0],
  [4,0,36,3,54804,0],
  [4,0,37,9,164413,0],
  [4,0,38,20,365362,0],
  [4,0,40,1,18268,0],
  [4,0,54,3,54804,0],
  [4,0,56,6,109608,0],
  [4,0,62,2,36536,0],
  [4,0,67,2,36536,0],
  [4,0,69,3,54804,0],
  [4,0,70,1,18268,0],
  [4,0,72,1,18268,0],
  [4,1,1,9,164413,0],
  [4,1,5,15,274021,0],
  [4,1,7,17,310557,0],
  [4,1,11,15,274021,0],
  [4,1,15,7,127877,0],
  [4,1,18,3,54804,0],
  [4,1,23,4,73072,0],
  [4,1,24,2,36536,0],
  [4,1,25,3,54804,0],
  [4,1,31,4,73072,0],
  [4,1,33,9,164413,0],
  [4,1,40,3,54804,0],
  [4,1,41,2,36536,0],
  [4,1,51,4,73072,0],
  [4,1,63,2,36536,0],
  [4,1,65,7,127877,0],
  [4,2,2,16,292289,0],
  [4,2,3,25,456702,0],
  [4,2,8,6,109608,0],
  [4,2,13,13,237485,0],
  [4,2,22,8,146145,0],
  [4,2,27,4,73072,0],
  [4,2,44,1,18268,0],
  [4,2,46,3,54804,0],
  [4,2,49,6,109608,0],
  [4,2,50,5,91340,0],
  [4,2,60,9,164413,0],
  [4,2,64,6,109608,0],
  [4,2,73,3,54804,0],
  [4,2,75,2,36536,0],
  [4,3,43,3,54804,0],
  [4,3,45,5,91340,0],
  [4,4,82,1,18268,0],
  [5,0,0,14,255753,0],
  [5,0,4,26,474970,0],
  [5,0,6,16,292289,0],
  [5,0,9,3,54804,0],
  [5,0,10,7,127877,0],
  [5,0,12,10,182681,0],
  [5,0,14,17,310557,0],
  [5,0,17,7,127877,0],
  [5,0,20,4,73072,0],
  [5,0,21,6,109608,0],
  [5,0,26,4,73072,0],
  [5,0,28,6,109608,0],
  [5,0,36,6,109608,0],
  [5,0,37,5,91340,0],
  [5,0,38,12,219217,0],
  [5,0,47,1,18268,0],
  [5,0,53,4,73072,0],
  [5,0,54,1,18268,0],
  [5,0,56,1,18268,0],
  [5,0,62,1,18268,0],
  [5,0,67,1,18268,0],
  [5,0,69,3,54804,0],
  [5,0,70,3,54804,0],
  [5,0,84,1,18268,0],
  [5,0,93,1,18268,0],
  [5,1,1,41,748991,0],
  [5,1,5,12,219217,0],
  [5,1,7,12,219217,0],
  [5,1,11,14,255753,0],
  [5,1,15,1,18268,0],
  [5,1,18,8,146145,0],
  [5,1,24,8,146145,0],
  [5,1,26,1,18268,0],
  [5,1,31,8,146145,0],
  [5,1,33,4,73072,0],
  [5,1,48,1,18268,0],
  [5,1,51,1,18268,0],
  [5,1,66,1,18268,0],
  [5,2,2,8,146145,0],
  [5,2,3,15,274021,0],
  [5,2,8,9,164413,0],
  [5,2,13,6,109608,0],
  [5,2,27,5,91340,0],
  [5,2,44,6,109608,0],
  [5,2,46,1,18268,0],
  [5,2,49,4,73072,0],
  [5,2,50,2,36536,0],
  [5,2,52,4,73072,0],
  [5,2,57,3,54804,0],
  [5,2,58,2,36536,0],
  [5,2,59,1,18268,0],
  [5,2,61,8,146145,0],
  [5,2,73,1,18268,0],
  [5,2,77,2,36536,0],
  [5,3,19,5,91340,0],
  [5,3,43,3,54804,0],
  [5,3,88,2,36536,0],
  [5,3,90,1,18268,0],
  [5,4,80,2,36536,0],
  [6,0,0,14,255753,0],
  [6,0,4,9,164413,0],
  [6,0,6,14,255753,0],
  [6,0,9,10,182681,0],
  [6,0,10,16,292289,0],
  [6,0,12,12,219217,0],
  [6,0,14,6,109608,0],
  [6,0,16,7,127877,0],
  [6,0,17,5,91340,0],
  [6,0,20,3,54804,0],
  [6,0,21,1,18268,0],
  [6,0,28,4,73072,0],
  [6,0,38,12,219217,0],
  [6,0,47,4,73072,0],
  [6,0,53,5,91340,0],
  [6,0,56,1,18268,0],
  [6,0,62,2,36536,0],
  [6,0,67,2,36536,0],
  [6,0,69,1,18268,0],
  [6,0,70,4,73072,0],
  [6,1,1,6,109608,0],
  [6,1,5,11,200949,0],
  [6,1,7,19,347094,0],
  [6,1,11,4,73072,0],
  [6,1,15,6,109608,0],
  [6,1,18,9,164413,0],
  [6,1,23,6,109608,0],
  [6,1,24,2,36536,0],
  [6,1,25,6,109608,0],
  [6,1,31,1,18268,0],
  [6,1,33,4,73072,0],
  [6,1,40,14,255753,0],
  [6,1,41,1,18268,0],
  [6,1,48,1,18268,0],
  [6,1,51,4,73072,0],
  [6,1,63,1,18268,0],
  [6,1,65,4,73072,0],
  [6,1,66,2,36536,0],
  [6,2,2,22,401898,0],
  [6,2,3,14,255753,0],
  [6,2,8,7,127877,0],
  [6,2,13,18,328825,0],
  [6,2,22,6,109608,0],
  [6,2,27,6,109608,0],
  [6,2,32,1,18268,0],
  [6,2,40,1,18268,0],
  [6,2,44,4,73072,0],
  [6,2,46,1,18268,0],
  [6,2,49,3,54804,0],
  [6,2,52,1,18268,0],
  [6,2,57,2,36536,0],
  [6,2,58,2,36536,0],
  [6,2,59,3,54804,0],
  [6,2,73,4,73072,0],
  [6,2,75,2,36536,0],
  [6,2,77,1,18268,0],
  [6,3,19,8,146145,0],
  [6,3,34,3,54804,0],
  [6,3,43,2,36536,0],
  [6,3,45,6,109608,0],
  [6,3,79,2,36536,0],
  [6,3,91,1,18268,0],
  [7,0,0,21,383630,0],
  [7,0,4,5,91340,0],
  [7,0,6,6,109608,0],
  [7,0,9,5,91340,0],
  [7,0,10,2,36536,0],
  [7,0,14,8,146145,0],
  [7,0,16,8,146145,0],
  [7,0,20,8,146145,0],
  [7,0,21,6,109608,0],
  [7,0,26,3,54804,0],
  [7,0,28,3,54804,0],
  [7,0,36,4,73072,0],
  [7,0,38,33,602847,0],
  [7,0,47,1,18268,0],
  [7,0,54,1,18268,0],
  [7,0,56,4,73072,0],
  [7,0,62,1,18268,0],
  [7,0,67,2,36536,0],
  [7,0,69,6,109608,0],
  [7,0,72,1,18268,0],
  [7,0,84,2,36536,0],
  [7,1,1,20,365362,0],
  [7,1,5,9,164413,0],
  [7,1,11,8,146145,0],
  [7,1,15,6,109608,0],
  [7,1,18,4,73072,0],
  [7,1,23,6,109608,0],
  [7,1,24,3,54804,0],
  [7,1,25,7,127877,0],
  [7,1,31,3,54804,0],
  [7,1,33,11,200949,0],
  [7,1,41,7,127877,0],
  [7,1,51,2,36536,0],
  [7,1,55,3,54804,0],
  [7,1,63,4,73072,0],
  [7,1,65,6,109608,0],
  [7,1,66,1,18268,0],
  [7,2,2,8,146145,0],
  [7,2,3,5,91340,0],
  [7,2,8,7,127877,0],
  [7,2,13,8,146145,0],
  [7,2,26,3,54804,0],
  [7,2,27,1,18268,0],
  [7,2,40,1,18268,0],
  [7,2,44,5,91340,0],
  [7,2,46,3,54804,0],
  [7,2,49,5,91340,0],
  [7,2,50,5,91340,0],
  [7,2,57,3,54804,0],
  [7,2,64,4,73072,0],
  [7,2,73,3,54804,0],
  [7,2,75,3,54804,0],
  [7,2,77,2,36536,0],
  [7,3,19,6,109608,0],
  [7,3,34,3,54804,0],
  [7,3,45,6,109608,0],
  [7,3,86,1,18268,0],
  [7,4,82,1,18268,0],
  [8,0,0,20,365362,0],
  [8,0,4,5,91340,0],
  [8,0,9,4,73072,0],
  [8,0,10,7,127877,0],
  [8,0,14,4,73072,0],
  [8,0,17,5,91340,0],
  [8,0,20,8,146145,0],
  [8,0,21,1,18268,0],
  [8,0,28,8,146145,0],
  [8,0,36,3,54804,0],
  [8,0,37,7,127877,0],
  [8,0,38,19,347094,0],
  [8,0,40,1,18268,0],
  [8,0,47,4,73072,0],
  [8,0,53,1,18268,0],
  [8,0,56,7,127877,0],
  [8,0,62,2,36536,0],
  [8,0,67,3,54804,0],
  [8,0,69,6,109608,0],
  [8,0,70,1,18268,0],
  [8,0,72,1,18268,0],
  [8,1,1,21,383630,0],
  [8,1,5,11,200949,0],
  [8,1,7,13,237485,0],
  [8,1,11,15,274021,0],
  [8,1,15,4,73072,0],
  [8,1,18,4,73072,0],
  [8,1,24,4,73072,0],
  [8,1,25,1,18268,0],
  [8,1,31,8,146145,0],
  [8,1,33,8,146145,0],
  [8,1,48,2,36536,0],
  [8,1,51,4,73072,0],
  [8,1,63,4,73072,0],
  [8,1,65,6,109608,0],
  [8,1,66,2,36536,0],
  [8,2,2,8,146145,0],
  [8,2,3,21,383630,0],
  [8,2,13,12,219217,0],
  [8,2,27,4,73072,0],
  [8,2,44,4,73072,0],
  [8,2,46,5,91340,0],
  [8,2,49,4,73072,0],
  [8,2,50,2,36536,0],
  [8,2,57,2,36536,0],
  [8,2,59,3,54804,1],
  [8,2,60,6,109608,0],
  [8,2,73,4,73072,0],
  [8,2,75,4,73072,0],
  [8,3,19,8,146145,0],
  [8,4,80,1,18268,0],
  [9,0,0,34,621115,0],
  [9,0,4,21,383630,0],
  [9,0,6,16,292289,0],
  [9,0,9,6,109608,0],
  [9,0,10,7,127877,0],
  [9,0,14,5,91340,0],
  [9,0,17,8,146145,0],
  [9,0,20,3,54804,0],
  [9,0,21,4,73072,0],
  [9,0,26,4,73072,0],
  [9,0,28,7,127877,0],
  [9,0,36,8,146145,0],
  [9,0,37,5,91340,0],
  [9,0,38,23,420166,0],
  [9,0,47,1,18268,0],
  [9,0,53,4,73072,0],
  [9,0,54,1,18268,0],
  [9,0,56,1,18268,0],
  [9,0,62,1,18268,0],
  [9,0,67,1,18268,0],
  [9,0,69,1,18268,0],
  [9,0,70,7,127877,0],
  [9,1,1,14,255753,0],
  [9,1,5,15,274021,0],
  [9,1,7,17,310557,0],
  [9,1,11,10,182681,0],
  [9,1,12,10,182681,0],
  [9,1,15,6,109608,0],
  [9,1,18,5,91340,0],
  [9,1,23,5,91340,0],
  [9,1,24,3,54804,0],
  [9,1,25,1,18268,0],
  [9,1,26,1,18268,0],
  [9,1,31,2,36536,0],
  [9,1,33,8,146145,0],
  [9,1,40,5,91340,0],
  [9,1,41,2,36536,0],
  [9,1,51,2,36536,0],
  [9,1,55,4,73072,0],
  [9,2,2,10,182681,0],
  [9,2,3,12,219217,0],
  [9,2,8,9,164413,0],
  [9,2,13,5,91340,0],
  [9,2,22,3,54804,0],
  [9,2,27,7,127877,0],
  [9,2,32,2,36536,0],
  [9,2,46,3,54804,0],
  [9,2,49,4,73072,0],
  [9,2,50,4,73072,0],
  [9,2,52,1,18268,0],
  [9,2,57,2,36536,0],
  [9,2,58,2,36536,0],
  [9,2,59,1,18268,0],
  [9,2,61,2,36536,0],
  [9,2,64,5,91340,0],
  [9,2,73,6,109608,0],
  [9,2,75,4,73072,0],
  [9,3,19,10,182681,0],
  [9,3,43,6,109608,0],
  [9,3,45,5,91340,0],
  [9,3,90,1,18268,0],
  [10,0,4,15,274021,0],
  [10,0,6,10,182681,0],
  [10,0,9,15,274021,0],
  [10,0,10,13,237485,0],
  [10,0,14,8,146145,0],
  [10,0,16,7,127877,0],
  [10,0,17,5,91340,0],
  [10,0,20,8,146145,0],
  [10,0,21,9,164413,0],
  [10,0,26,2,36536,0],
  [10,0,28,6,109608,0],
  [10,0,37,7,127877,0],
  [10,0,38,18,328825,0],
  [10,0,47,1,18268,0],
  [10,0,53,2,36536,0],
  [10,0,62,2,36536,0],
  [10,0,67,4,73072,0],
  [10,0,69,4,73072,0],
  [10,0,70,2,36536,0],
  [10,1,1,13,237485,0],
  [10,1,5,18,328825,0],
  [10,1,7,7,127877,0],
  [10,1,11,3,54804,0],
  [10,1,12,4,73072,0],
  [10,1,15,2,36536,0],
  [10,1,18,13,237485,0],
  [10,1,24,1,18268,0],
  [10,1,25,7,127877,0],
  [10,1,31,5,91340,0],
  [10,1,33,5,91340,0],
  [10,1,41,1,18268,0],
  [10,1,51,3,54804,0],
  [10,1,63,4,73072,0],
  [10,2,2,24,438434,0],
  [10,2,3,24,438434,0],
  [10,2,8,9,164413,0],
  [10,2,13,10,182681,0],
  [10,2,22,4,73072,0],
  [10,2,27,2,36536,0],
  [10,2,44,3,54804,0],
  [10,2,46,2,36536,0],
  [10,2,49,1,18268,0],
  [10,2,50,1,18268,0],
  [10,2,52,13,237485,0],
  [10,2,58,4,73072,0],
  [10,2,61,3,54804,0],
  [10,2,73,4,73072,0],
  [10,2,77,1,18268,0],
  [10,3,34,4,73072,0],
  [10,3,45,6,109608,0],
  [10,3,83,1,18268,0],
  [10,3,86,1,18268,0],
  [10,3,88,2,36536,0],
  [10,3,91,1,18268,0],
  [10,3,100,1,18268,0],
  [11,0,0,19,347094,0],
  [11,0,4,1,18268,0],
  [11,0,6,12,219217,0],
  [11,0,9,4,73072,0],
  [11,0,10,5,91340,0],
  [11,0,14,4,73072,0],
  [11,0,16,20,365362,0],
  [11,0,17,1,18268,0],
  [11,0,20,5,91340,0],
  [11,0,21,8,146145,0],
  [11,0,28,3,54804,0],
  [11,0,38,21,383630,0],
  [11,0,47,3,54804,0],
  [11,0,53,2,36536,0],
  [11,0,56,7,127877,0],
  [11,0,62,1,18268,0],
  [11,0,69,2,36536,0],
  [11,0,72,1,18268,0],
  [11,1,1,25,456702,0],
  [11,1,5,17,310557,0],
  [11,1,7,8,146145,0],
  [11,1,11,19,347094,0],
  [11,1,12,6,109608,0],
  [11,1,15,8,146145,0],
  [11,1,18,3,54804,0],
  [11,1,24,2,36536,0],
  [11,1,25,6,109608,0],
  [11,1,31,4,73072,0],
  [11,1,33,10,182681,0],
  [11,1,41,4,73072,0],
  [11,1,51,2,36536,0],
  [11,1,63,2,36536,0],
  [11,1,65,10,182681,0],
  [11,2,2,10,182681,0],
  [11,2,3,24,438434,0],
  [11,2,8,6,109608,0],
  [11,2,13,14,255753,0],
  [11,2,22,2,36536,0],
  [11,2,26,2,36536,0],
  [11,2,27,2,36536,0],
  [11,2,40,2,36536,0],
  [11,2,44,8,146145,0],
  [11,2,46,2,36536,0],
  [11,2,49,9,164413,0],
  [11,2,50,3,54804,0],
  [11,2,52,3,54804,0],
  [11,2,57,3,54804,0],
  [11,2,59,4,73072,0],
  [11,2,77,1,18268,0],
  [11,3,19,12,219217,0],
  [11,3,34,2,36536,0],
  [11,3,43,4,73072,0],
  [11,3,79,2,36536,0],
  [11,4,82,1,18268,0],
  [12,0,0,24,438434,0],
  [12,0,4,8,146145,0],
  [12,0,6,9,164413,0],
  [12,0,9,7,127877,0],
  [12,0,10,3,54804,0],
  [12,0,14,8,146145,0],
  [12,0,17,6,109608,0],
  [12,0,20,9,164413,0],
  [12,0,21,4,73072,0],
  [12,0,28,7,127877,0],
  [12,0,38,14,255753,0],
  [12,0,47,4,73072,0],
  [12,0,53,1,18268,0],
  [12,0,56,2,36536,0],
  [12,0,62,1,18268,0],
  [12,0,69,5,91340,0],
  [12,0,70,1,18268,0],
  [12,0,72,1,18268,0],
  [12,0,84,3,54804,0],
  [12,1,1,13,237485,0],
  [12,1,5,13,237485,0],
  [12,1,7,15,274021,0],
  [12,1,11,4,73072,0],
  [12,1,12,2,36536,0],
  [12,1,15,6,109608,0],
  [12,1,18,6,109608,0],
  [12,1,23,6,109608,0],
  [12,1,24,4,73072,0],
  [12,1,25,5,91340,0],
  [12,1,31,3,54804,0],
  [12,1,33,9,164413,0],
  [12,1,40,1,18268,0],
  [12,1,41,2,36536,0],
  [12,1,48,2,36536,0],
  [12,1,51,5,91340,0],
  [12,1,63,3,54804,0],
  [12,1,66,7,127877,0],
  [12,2,2,20,365362,0],
  [12,2,3,12,219217,0],
  [12,2,8,7,127877,0],
  [12,2,13,9,164413,0],
  [12,2,22,5,91340,0],
  [12,2,26,1,18268,0],
  [12,2,27,2,36536,0],
  [12,2,32,2,36536,0],
  [12,2,44,6,109608,0],
  [12,2,46,4,73072,0],
  [12,2,49,1,18268,0],
  [12,2,50,1,18268,0],
  [12,2,52,1,18268,0],
  [12,2,57,3,54804,0],
  [12,2,59,1,18268,0],
  [12,2,64,4,73072,0],
  [12,2,73,6,109608,0],
  [12,2,75,5,91340,0],
  [12,2,77,2,36536,0],
  [12,3,34,1,18268,0],
  [12,3,45,5,91340,0],
  [12,3,90,1,18268,0],
  [12,4,84,1,18268,0],
  [13,0,0,25,466347,0],
  [13,0,4,14,261380,0],
  [13,0,6,5,91340,0],
  [13,0,9,11,204968,0],
  [13,0,10,6,111216,0],
  [13,0,14,9,168030,0],
  [13,0,17,5,92546,0],
  [13,0,20,4,73876,0],
  [13,0,21,1,18670,0],
  [13,0,26,3,56010,0],
  [13,0,28,12,223236,0],
  [13,0,37,10,186700,0],
  [13,0,38,24,445266,0],
  [13,0,40,11,200949,0],
  [13,0,53,1,18670,0],
  [13,0,54,2,37340,0],
  [13,0,56,3,54804,0],
  [13,0,62,3,54804,0],
  [13,0,67,5,92144,0],
  [13,0,69,4,74278,0],
  [13,0,70,3,55206,0],
  [13,1,1,16,296308,0],
  [13,1,5,18,333648,0],
  [13,1,7,10,186700,0],
  [13,1,11,9,167226,0],
  [13,1,12,2,37340,0],
  [13,1,15,6,110412,0],
  [13,1,18,5,93350,0],
  [13,1,23,6,112020,0],
  [13,1,24,3,55608,0],
  [13,1,25,3,56010,0],
  [13,1,26,1,18670,0],
  [13,1,31,8,147752,0],
  [13,1,33,3,54804,0],
  [13,1,40,9,164413,0],
  [13,1,41,5,92144,0],
  [13,1,51,1,18670,0],
  [13,1,55,2,37340,0],
  [13,1,63,2,37340,0],
  [13,1,65,6,112020,0],
  [13,2,3,7,130690,0],
  [13,2,13,9,168030,0],
  [13,2,40,8,149360,0],
  [13,2,44,3,55608,0],
  [13,2,46,3,56010,0],
  [13,2,49,2,37340,0],
  [13,2,50,5,93350,0],
  [13,2,52,1,18670,0],
  [13,2,60,9,168030,0],
  [13,2,64,5,93350,0],
  [13,2,73,1,18670,0],
  [13,2,77,2,36536,0],
  [13,3,19,8,146145,0],
  [13,3,43,4,73474,0],
  [13,3,83,1,18268,0],
  [13,3,88,1,18268,0],
  [14,0,4,17,317389,0],
  [14,0,6,12,224040,0],
  [14,0,9,12,224040,0],
  [14,0,10,9,168030,0],
  [14,0,14,5,93350,0],
  [14,0,17,5,93350,0],
  [14,0,20,3,56010,0],
  [14,0,21,8,149360,0],
  [14,0,28,2,37340,0],
  [14,0,37,5,93350,0],
  [14,0,38,27,504089,0],
  [14,0,53,5,93350,0],
  [14,0,54,1,18670,0],
  [14,0,69,2,37340,0],
  [14,0,70,2,37340,0],
  [14,1,1,14,261380,0],
  [14,1,5,15,280050,0],
  [14,1,7,10,186700,0],
  [14,1,11,10,186700,0],
  [14,1,12,6,112020,0],
  [14,1,15,2,37340,0],
  [14,1,18,10,186700,0],
  [14,1,24,3,56010,0],
  [14,1,25,7,130690,0],
  [14,1,31,4,74680,0],
  [14,1,33,10,186700,0],
  [14,1,42,3,56010,0],
  [14,1,51,4,74680,0],
  [14,1,55,2,37340,0],
  [14,2,2,26,485419,0],
  [14,2,3,18,336059,0],
  [14,2,8,14,261380,0],
  [14,2,13,14,261380,0],
  [14,2,22,1,18670,0],
  [14,2,27,8,149360,0],
  [14,2,32,5,93350,0],
  [14,2,44,6,112020,0],
  [14,2,46,1,18670,0],
  [14,2,49,6,112020,0],
  [14,2,50,4,74680,0],
  [14,2,52,2,37340,0],
  [14,2,58,5,93350,0],
  [14,2,59,1,18670,0],
  [14,2,75,2,37340,0],
  [14,3,19,8,149360,0],
  [14,3,34,2,37340,0],
  [14,3,43,2,37340,0],
  [14,3,45,5,93350,0],
  [14,3,100,1,18670,0],
  [14,3,104,1,18670,0],
  [15,0,0,24,448079,0],
  [15,0,4,8,149360,0],
  [15,0,6,17,317389,0],
  [15,0,9,2,37340,0],
  [15,0,10,4,74680,0],
  [15,0,14,10,186700,0],
  [15,0,20,4,74680,0],
  [15,0,21,2,37340,0],
  [15,0,26,2,37340,0],
  [15,0,28,6,112020,0],
  [15,0,38,17,317389,0],
  [15,0,47,4,74680,0],
  [15,0,53,1,18670,0],
  [15,0,54,1,18670,0],
  [15,0,56,6,112020,0],
  [15,0,62,4,74680,0],
  [15,0,67,1,18670,0],
  [15,0,69,3,56010,0],
  [15,0,72,1,18670,0],
  [15,1,1,12,224040,0],
  [15,1,5,10,186700,0],
  [15,1,7,20,373399,0],
  [15,1,11,9,168030,0],
  [15,1,12,2,37340,0],
  [15,1,15,7,130690,0],
  [15,1,18,13,242710,0],
  [15,1,23,5,93350,0],
  [15,1,24,2,37340,0],
  [15,1,25,2,37340,0],
  [15,1,26,2,37340,0],
  [15,1,31,2,37340,0],
  [15,1,33,11,205370,0],
  [15,1,41,2,37340,0],
  [15,1,51,3,56010,0],
  [15,1,63,4,74680,0],
  [15,2,2,20,373399,0],
  [15,2,3,13,242710,0],
  [15,2,13,7,130690,0],
  [15,2,22,8,149360,0],
  [15,2,26,2,37340,0],
  [15,2,27,2,37340,0],
  [15,2,32,1,18670,0],
  [15,2,40,2,37340,0],
  [15,2,44,5,93350,0],
  [15,2,46,4,74680,0],
  [15,2,49,5,93350,0],
  [15,2,50,5,93350,0],
  [15,2,52,2,37340,0],
  [15,2,57,10,186700,0],
  [15,2,59,2,37340,0],
  [15,2,64,3,56010,0],
  [15,3,19,6,112020,0],
  [15,3,34,5,93350,0],
  [15,3,43,3,56010,0],
  [15,3,45,5,93350,0],
  [15,3,91,1,18670,0],
  [16,0,0,15,280050,0],
  [16,0,4,3,56010,0],
  [16,0,6,9,168030,0],
  [16,0,9,8,149360,0],
  [16,0,10,7,130690,0],
  [16,0,17,5,93350,0],
  [16,0,20,7,130690,0],
  [16,0,21,3,56010,0],
  [16,0,28,5,93350,0],
  [16,0,38,17,317389,0],
  [16,0,47,3,56010,0],
  [16,0,53,1,18670,0],
  [16,0,54,3,56010,0],
  [16,0,56,3,56010,0],
  [16,0,62,4,74680,0],
  [16,0,67,1,18670,0],
  [16,0,69,2,37340,0],
  [16,0,70,3,56010,0],
  [16,1,1,25,466749,0],
  [16,1,5,10,186700,0],
  [16,1,7,8,149360,0],
  [16,1,11,16,298720,0],
  [16,1,12,6,112020,0],
  [16,1,15,2,37340,0],
  [16,1,18,7,130690,0],
  [16,1,24,2,37340,0],
  [16,1,25,7,130690,0],
  [16,1,33,3,56010,0],
  [16,1,41,6,112020,0],
  [16,1,48,2,37340,0],
  [16,1,51,4,74680,0],
  [16,1,65,6,112020,0],
  [16,2,2,20,373399,0],
  [16,2,3,15,280050,0],
  [16,2,8,7,130690,0],
  [16,2,13,7,130690,0],
  [16,2,26,7,130690,0],
  [16,2,27,7,130690,0],
  [16,2,44,3,56010,0],
  [16,2,46,2,37340,0],
  [16,2,49,3,56010,0],
  [16,2,50,2,37340,0],
  [16,2,57,6,112020,0],
  [16,2,59,3,56010,0],
  [16,2,60,5,93350,0],
  [16,2,73,3,56010,0],
  [16,3,19,12,224040,0],
  [16,3,34,1,18670,0],
  [16,3,43,2,37340,0],
  [16,3,45,5,93350,0],
  [16,3,86,1,18670,0],
  [16,3,88,1,18670,0],
  [16,4,80,1,18670,0],
  [16,4,82,1,18670,0],
  [17,0,0,16,298720,0],
  [17,0,4,9,168030,0],
  [17,0,6,9,168030,0],
  [17,0,9,13,242710,0],
  [17,0,10,5,93350,0],
  [17,0,14,9,168030,0],
  [17,0,16,12,224040,0],
  [17,0,17,7,130690,0],
  [17,0,20,11,205370,0],
  [17,0,21,8,149360,0],
  [17,0,28,12,224040,0],
  [17,0,37,7,130690,0],
  [17,0,38,25,466749,1],
  [17,0,47,2,37340,0],
  [17,0,53,2,37340,0],
  [17,0,54,3,56010,0],
  [17,0,56,2,37340,0],
  [17,0,62,3,56010,0],
  [17,0,67,2,37340,0],
  [17,0,69,5,93350,0],
  [17,1,1,10,186700,0],
  [17,1,5,18,336059,0],
  [17,1,7,14,261380,0],
  [17,1,11,8,149360,0],
  [17,1,12,4,74680,0],
  [17,1,15,3,56010,0],
  [17,1,18,3,56010,0],
  [17,1,23,5,93350,0],
  [17,1,24,4,74680,0],
  [17,1,25,1,18670,0],
  [17,1,31,6,112020,0],
  [17,1,33,3,56010,0],
  [17,1,40,1,18670,0],
  [17,1,41,1,18670,0],
  [17,1,51,3,56010,0],
  [17,1,55,2,37340,0],
  [17,1,65,6,112020,0],
  [17,2,2,6,112020,0],
  [17,2,3,9,168030,0],
  [17,2,8,16,298720,0],
  [17,2,13,12,224040,0],
  [17,2,22,2,37340,0],
  [17,2,27,1,18670,0],
  [17,2,32,1,18670,0],
  [17,2,46,5,93350,0],
  [17,2,50,5,93350,0],
  [17,2,64,3,56010,0],
  [17,2,73,5,93350,0],
  [17,2,75,3,56010,0],
  [17,3,43,7,130690,0],
  [17,3,90,1,18670,0],
  [18,0,0,29,541429,0],
  [18,0,4,11,205370,0],
  [18,0,6,10,186700,0],
  [18,0,9,12,224040,0],
  [18,0,10,4,74680,0],
  [18,0,14,4,74680,0],
  [18,0,17,4,74680,0],
  [18,0,20,3,56010,0],
  [18,0,21,3,56010,0],
  [18,0,26,5,93350,0],
  [18,0,28,1,18670,0],
  [18,0,37,6,112020,0],
  [18,0,38,23,429409,0],
  [18,0,40,1,18670,0],
  [18,0,47,2,37340,0],
  [18,0,53,4,74680,0],
  [18,0,54,1,18670,0],
  [18,0,56,2,37340,0],
  [18,0,67,4,74680,0],
  [18,0,69,1,18670,0],
  [18,0,70,4,74680,0],
  [18,1,1,12,224040,0],
  [18,1,5,10,186700,0],
  [18,1,7,7,130690,0],
  [18,1,11,12,224040,0],
  [18,1,12,9,168030,0],
  [18,1,15,5,93350,0],
  [18,1,18,6,112020,0],
  [18,1,23,5,93350,0],
  [18,1,24,1,18670,0],
  [18,1,25,5,93350,0],
  [18,1,26,1,18670,0],
  [18,1,31,9,168030,0],
  [18,1,33,18,336059,0],
  [18,1,40,2,37340,0],
  [18,1,41,1,18670,0],
  [18,1,51,3,56010,0],
  [18,1,63,4,74680,0],
  [18,1,65,3,56010,0],
  [18,2,2,8,149360,0],
  [18,2,3,23,429409,0],
  [18,2,13,8,149360,0],
  [18,2,22,3,56010,0],
  [18,2,27,2,37340,0],
  [18,2,32,1,18670,0],
  [18,2,44,1,18670,0],
  [18,2,50,3,56010,0],
  [18,2,52,1,18670,0],
  [18,2,58,2,37340,0],
  [18,2,60,6,112020,0],
  [18,2,61,3,56010,0],
  [18,2,64,4,74680,0],
  [18,3,19,6,112020,0],
  [18,3,34,1,18670,0],
  [18,3,43,3,56010,0],
  [18,3,45,7,130690,0],
  [18,3,79,2,37340,0],
  [18,3,88,3,56010,0],
  [18,3,104,1,18670,0],
  [18,4,92,3,56010,0],
  [19,0,0,26,485419,0],
  [19,0,4,10,186700,0],
  [19,0,6,16,298720,0],
  [19,0,9,6,112020,0],
  [19,0,10,10,186700,0],
  [19,0,14,6,112020,0],
  [19,0,17,3,56010,0],
  [19,0,20,5,93350,0],
  [19,0,21,5,93350,0],
  [19,0,26,1,18670,0],
  [19,0,28,6,112020,0],
  [19,0,37,8,149360,0],
  [19,0,38,11,205370,0],
  [19,0,53,3,56010,0],
  [19,0,54,0,0,1],
  [19,0,56,6,112020,0],
  [19,0,62,3,56010,0],
  [19,0,69,6,112020,0],
  [19,0,70,2,37340,0],
  [19,0,72,1,18670,0],
  [19,0,84,1,18670,0],
  [19,1,1,16,298720,0],
  [19,1,5,21,392069,0],
  [19,1,7,19,354729,0],
  [19,1,11,15,280050,0],
  [19,1,12,3,56010,0],
  [19,1,15,7,130690,0],
  [19,1,18,4,74680,0],
  [19,1,24,2,37340,0],
  [19,1,25,6,112020,0],
  [19,1,31,5,93350,0],
  [19,1,33,6,112020,0],
  [19,1,41,4,74680,0],
  [19,1,51,2,37340,0],
  [19,1,63,5,93350,0],
  [19,1,65,4,74680,0],
  [19,2,2,18,336059,0],
  [19,2,3,18,336059,0],
  [19,2,8,8,149360,0],
  [19,2,13,16,298720,0],
  [19,2,22,3,56010,0],
  [19,2,27,5,93350,0],
  [19,2,40,2,37340,0],
  [19,2,44,5,93350,0],
  [19,2,46,2,37340,0],
  [19,2,49,7,130690,0],
  [19,2,50,4,74680,0],
  [19,2,52,2,37340,0],
  [19,2,58,4,74680,0],
  [19,2,59,5,93350,0],
  [19,2,61,2,37340,0],
  [19,2,64,3,56010,0],
  [19,2,73,1,18670,0],
  [19,2,75,4,74680,0],
  [19,3,19,8,149360,0],
  [19,3,34,4,74680,0],
  [19,3,43,2,37340,0],
  [19,3,91,1,18670,0],
  [19,3,100,1,18670,0],
  [20,0,0,25,466749,0],
  [20,0,4,7,130690,0],
  [20,0,6,13,242710,0],
  [20,0,9,5,93350,0],
  [20,0,10,9,168030,0],
  [20,0,14,12,224040,0],
  [20,0,17,7,130690,0],
  [20,0,20,4,74680,0],
  [20,0,21,9,168030,0],
  [20,0,26,7,130690,0],
  [20,0,28,6,112020,0],
  [20,0,38,31,578769,0],
  [20,0,47,2,37340,0],
  [20,0,53,1,18670,0],
  [20,0,54,1,18670,0],
  [20,0,56,2,37340,0],
  [20,0,62,3,56010,0],
  [20,0,67,1,18670,0],
  [20,0,69,2,37340,0],
  [20,0,70,4,74680,0],
  [20,1,5,3,56010,0],
  [20,1,7,12,224040,0],
  [20,1,11,7,130690,0],
  [20,1,12,4,74680,0],
  [20,1,15,4,74680,0],
  [20,1,18,11,205370,0],
  [20,1,23,5,93350,0],
  [20,1,24,3,56010,0],
  [20,1,25,5,93350,0],
  [20,1,30,20,373399,0],
  [20,1,33,15,280050,0],
  [20,1,41,2,37340,0],
  [20,1,48,1,18670,0],
  [20,1,51,5,93350,0],
  [20,1,55,3,56010,0],
  [20,1,63,3,56010,0],
  [20,1,65,10,186700,0],
  [20,2,2,10,186700,0],
  [20,2,3,15,280050,0],
  [20,2,8,7,130690,0],
  [20,2,22,6,112020,0],
  [20,2,26,3,56010,0],
  [20,2,27,5,93350,0],
  [20,2,32,2,37340,0],
  [20,2,44,7,130690,0],
  [20,2,46,6,112020,0],
  [20,2,49,4,74680,0],
  [20,2,50,2,37340,0],
  [20,2,52,1,18670,0],
  [20,2,59,5,93350,0],
  [20,2,61,3,56010,0],
  [20,2,73,2,37340,0],
  [20,2,75,3,56010,0],
  [20,3,19,8,149360,0],
  [20,3,34,1,18670,0],
  [20,3,43,1,18670,0],
  [21,0,0,2,37340,0],
  [21,0,4,3,56010,0],
  [21,0,6,6,112020,0],
  [21,0,9,8,149360,0],
  [21,0,10,6,112020,0],
  [21,0,14,2,37340,0],
  [21,0,17,2,37340,0],
  [21,0,20,13,242710,0],
  [21,0,21,4,74680,0],
  [21,0,26,4,74680,0],
  [21,0,28,4,74680,0],
  [21,0,38,24,448079,0],
  [21,0,47,4,74680,0],
  [21,0,53,2,37340,0],
  [21,0,56,3,56010,0],
  [21,0,62,2,37340,0],
  [21,0,69,4,74680,0],
  [21,0,70,2,37340,0],
  [21,1,5,17,317389,0],
  [21,1,7,6,112020,0],
  [21,1,11,9,168030,0],
  [21,1,12,9,168030,0],
  [21,1,15,3,56010,0],
  [21,1,18,7,130690,0],
  [21,1,23,6,112020,0],
  [21,1,24,3,56010,0],
  [21,1,25,1,18670,0],
  [21,1,26,31,578769,0],
  [21,1,30,20,373399,0],
  [21,1,31,3,56010,0],
  [21,1,40,2,37340,0],
  [21,1,41,1,18670,0],
  [21,1,51,4,74680,0],
  [21,1,55,1,18670,0],
  [21,1,65,2,37340,0],
  [21,2,2,10,186700,0],
  [21,2,3,5,93350,0],
  [21,2,8,7,130690,0],
  [21,2,13,11,205370,0],
  [21,2,27,2,37340,0],
  [21,2,32,3,56010,0],
  [21,2,44,8,149360,0],
  [21,2,46,1,18670,0],
  [21,2,49,5,93350,0],
  [21,2,50,6,112020,0],
  [21,2,64,4,74680,0],
  [21,2,73,1,18670,0],
  [21,2,75,2,37340,0],
  [21,3,19,6,112020,0],
  [21,3,34,1,18670,0],
  [21,3,43,3,56010,0],
  [21,3,45,6,112020,0],
  [21,3,86,1,18670,0],
  [22,0,0,24,448079,0],
  [22,0,4,16,298720,0],
  [22,0,6,5,93350,0],
  [22,0,9,9,168030,0],
  [22,0,10,2,37340,0],
  [22,0,14,8,149360,0],
  [22,0,16,12,224040,0],
  [22,0,17,9,168030,0],
  [22,0,20,5,93350,0],
  [22,0,21,7,130690,0],
  [22,0,26,1,18670,0],
  [22,0,28,4,74680,0],
  [22,0,37,8,149360,0],
  [22,0,38,23,429409,0],
  [22,0,53,2,37340,0],
  [22,0,54,2,37340,0],
  [22,0,67,3,56010,0],
  [22,0,69,4,74680,0],
  [22,0,70,10,186700,0],
  [22,1,5,11,205370,0],
  [22,1,7,10,186700,0],
  [22,1,11,13,242710,0],
  [22,1,12,2,37340,0],
  [22,1,18,5,93350,0],
  [22,1,24,4,74680,0],
  [22,1,25,6,112020,0],
  [22,1,26,19,354729,0],
  [22,1,30,14,261380,0],
  [22,1,31,3,56010,0],
  [22,1,33,8,149360,0],
  [22,1,40,1,18670,0],
  [22,1,41,5,93350,0],
  [22,1,48,1,18670,0],
  [22,1,51,3,56010,0],
  [22,1,63,2,37340,0],
  [22,1,65,10,186700,0],
  [22,2,2,22,410739,0],
  [22,2,3,20,373399,0],
  [22,2,8,7,130690,0],
  [22,2,13,8,149360,0],
  [22,2,26,2,37340,0],
  [22,2,27,3,56010,0],
  [22,2,32,5,93350,0],
  [22,2,46,3,56010,0],
  [22,2,49,4,74680,0],
  [22,2,50,7,130690,0],
  [22,2,57,4,74680,0],
  [22,2,58,4,74680,0],
  [22,2,59,1,18670,0],
  [22,2,60,6,112020,0],
  [22,2,64,3,56010,0],
  [22,2,75,3,56010,0],
  [22,3,19,8,149360,0],
  [22,3,43,4,74680,0],
  [22,3,86,1,18670,0],
  [22,3,88,1,18670,0],
  [22,3,90,1,18670,0],
  [22,4,82,1,18670,0],
  [23,0,0,10,186700,0],
  [23,0,4,11,205370,0],
  [23,0,6,17,317389,0],
  [23,0,9,7,130690,0],
  [23,0,10,12,224040,0],
  [23,0,14,5,93350,0],
  [23,0,17,1,18670,0],
  [23,0,20,1,18670,0],
  [23,0,21,4,74680,0],
  [23,0,26,3,56010,0],
  [23,0,28,5,93350,0],
  [23,0,37,5,93350,0],
  [23,0,38,23,429409,0],
  [23,0,40,2,37340,0],
  [23,0,47,3,56010,0],
  [23,0,53,2,37340,0],
  [23,0,56,5,93350,0],
  [23,0,62,3,56010,0],
  [23,0,67,2,37340,0],
  [23,0,69,1,18670,0],
  [23,0,70,2,37340,0],
  [23,0,72,1,18670,0],
  [23,0,84,1,18670,0],
  [23,1,5,22,410739,0],
  [23,1,7,16,298720,0],
  [23,1,11,8,149360,0],
  [23,1,12,6,112020,0],
  [23,1,18,12,224040,0],
  [23,1,23,7,130690,0],
  [23,1,24,2,37340,0],
  [23,1,25,7,130690,0],
  [23,1,30,6,112020,0],
  [23,1,31,5,93350,0],
  [23,1,33,14,261380,0],
  [23,1,40,1,18670,0],
  [23,1,41,3,56010,0],
  [23,1,48,2,37340,0],
  [23,1,51,5,93350,0],
  [23,1,55,3,56010,0],
  [23,1,63,4,74680,0],
  [23,2,2,18,336059,0],
  [23,2,3,8,149360,0],
  [23,2,8,7,130690,0],
  [23,2,13,15,280050,0],
  [23,2,15,7,130690,0],
  [23,2,22,5,93350,0],
  [23,2,27,8,149360,0],
  [23,2,44,3,56010,0],
  [23,2,46,1,18670,0],
  [23,2,49,4,74680,0],
  [23,2,50,2,37340,0],
  [23,2,52,2,37340,0],
  [23,2,57,1,18670,0],
  [23,2,59,2,37340,0],
  [23,2,61,5,93350,0],
  [23,2,73,2,37340,0],
  [23,2,75,2,37340,0],
  [23,3,45,7,130690,0],
  [23,3,79,2,37340,0],
  [23,3,88,2,37340,0],
  [23,3,100,1,18670,0],
  [24,0,0,23,429409,0],
  [24,0,4,6,112020,0],
  [24,0,6,15,280050,0],
  [24,0,9,11,205370,0],
  [24,0,10,12,224040,0],
  [24,0,14,15,280050,0],
  [24,0,17,3,56010,0],
  [24,0,20,9,168030,0],
  [24,0,21,5,93350,0],
  [24,0,28,7,130690,0],
  [24,0,38,18,336059,0],
  [24,0,47,3,56010,0],
  [24,0,53,3,56010,0],
  [24,0,56,5,93350,0],
  [24,0,62,2,37340,0],
  [24,0,67,1,18670,0],
  [24,0,69,4,74680,0],
  [24,0,70,8,149360,0],
  [24,1,5,10,186700,0],
  [24,1,7,5,93350,0],
  [24,1,11,4,74680,0],
  [24,1,12,10,186700,0],
  [24,1,18,7,130690,0],
  [24,1,24,2,37340,0],
  [24,1,25,5,93350,0],
  [24,1,30,28,522759,0],
  [24,1,31,6,112020,0],
  [24,1,33,10,186700,0],
  [24,1,40,2,37340,0],
  [24,1,41,3,56010,0],
  [24,1,51,4,74680,0],
  [24,1,55,2,37340,0],
  [24,1,63,2,37340,0],
  [24,1,65,4,74680,0],
  [24,2,2,8,149360,0],
  [24,2,3,28,522759,0],
  [24,2,8,7,130690,0],
  [24,2,13,10,186700,0],
  [24,2,15,2,37340,0],
  [24,2,22,2,37340,0],
  [24,2,26,2,37340,0],
  [24,2,27,7,130690,0],
  [24,2,32,4,74680,0],
  [24,2,40,1,18670,0],
  [24,2,44,8,149360,0],
  [24,2,46,1,18670,0],
  [24,2,49,3,56010,0],
  [24,2,50,8,149360,0],
  [24,2,61,2,37340,0],
  [24,2,73,2,37340,0],
  [24,2,75,1,18670,0],
  [24,3,19,10,186700,0],
  [24,3,34,6,112020,0],
  [24,3,43,7,130690,0],
  [24,3,91,1,18670,0],
  [25,0,0,15,280050,0],
  [25,0,4,11,205370,0],
  [25,0,6,5,93350,0],
  [25,0,9,5,93350,0],
  [25,0,10,5,93350,0],
  [25,0,14,7,130690,0],
  [25,0,16,12,224040,0],
  [25,0,17,5,93350,0],
  [25,0,20,10,186700,0],
  [25,0,21,4,74680,0],
  [25,0,26,2,37340,0],
  [25,0,28,4,74680,0],
  [25,0,38,27,504089,0],
  [25,0,47,1,18670,0],
  [25,0,53,2,37340,0],
  [25,0,54,1,18670,0],
  [25,0,56,2,37340,0],
  [25,0,69,5,93350,0],
  [25,0,70,2,37340,0],
  [25,0,84,1,18670,0],
  [25,1,5,10,186700,0],
  [25,1,7,22,410739,0],
  [25,1,11,15,280050,0],
  [25,1,12,3,56010,0],
  [25,1,18,13,242710,0],
  [25,1,23,5,93350,0],
  [25,1,24,6,112020,0],
  [25,1,25,4,74680,0],
  [25,1,26,7,130690,0],
  [25,1,30,27,504089,0],
  [25,1,31,4,74680,0],
  [25,1,33,2,37340,0],
  [25,1,40,4,74680,0],
  [25,1,41,1,18670,0],
  [25,1,48,1,18670,0],
  [25,1,51,5,93350,0],
  [25,1,65,4,74680,0],
  [25,2,2,20,373399,0],
  [25,2,3,31,578769,0],
  [25,2,8,7,130690,0],
  [25,2,13,9,168030,0],
  [25,2,26,4,74680,0],
  [25,2,27,3,56010,0],
  [25,2,32,2,37340,0],
  [25,2,44,2,37340,0],
  [25,2,46,5,93350,0],
  [25,2,49,4,74680,0],
  [25,2,50,4,74680,0],
  [25,2,58,3,56010,0],
  [25,2,59,2,37340,0],
  [25,2,60,5,93350,0],
  [25,2,64,5,93350,0],
  [25,2,75,2,37340,0],
  [25,3,34,1,18670,0],
  [25,3,45,3,56010,0],
  [26,0,0,32,597439,0],
  [26,0,4,15,280050,0],
  [26,0,6,12,224040,0],
  [26,0,9,10,186700,0],
  [26,0,10,4,74680,0],
  [26,0,14,5,93350,0],
  [26,0,16,8,149360,0],
  [26,0,17,6,112020,0],
  [26,0,20,2,37340,0],
  [26,0,21,10,186700,0],
  [26,0,28,10,186700,0],
  [26,0,38,22,410739,0],
  [26,0,47,1,18670,0],
  [26,0,56,3,56010,0],
  [26,0,62,3,56010,0],
  [26,0,67,3,56010,0],
  [26,0,69,2,37340,0],
  [26,0,70,2,37340,0],
  [26,1,5,10,186700,0],
  [26,1,7,7,130690,0],
  [26,1,11,14,261380,0],
  [26,1,12,2,37340,0],
  [26,1,18,7,130690,0],
  [26,1,24,2,37340,0],
  [26,1,25,3,56010,0],
  [26,1,30,12,224040,0],
  [26,1,31,4,74680,0],
  [26,1,33,5,93350,0],
  [26,1,40,4,74680,0],
  [26,1,41,7,130690,0],
  [26,1,48,2,37340,0],
  [26,1,51,3,56010,0],
  [26,1,63,2,37340,0],
  [26,1,65,12,224040,0],
  [26,2,2,18,336059,0],
  [26,2,3,15,280050,0],
  [26,2,13,8,149360,0],
  [26,2,15,2,37340,0],
  [26,2,27,1,18670,0],
  [26,2,32,3,56010,0],
  [26,2,44,4,74680,0],
  [26,2,46,2,37340,0],
  [26,2,50,3,56010,0],
  [26,2,57,2,37340,0],
  [26,2,64,5,93350,0],
  [26,2,73,2,37340,0],
  [26,2,75,2,37340,0],
  [26,3,19,10,186700,0],
  [26,3,90,1,18670,0],
  [26,3,95,2,37340,0],
  [26,4,82,3,56010,0],
  [26,4,92,1,18670,0],
  [27,0,0,11,205370,0],
  [27,0,4,6,112020,0],
  [27,0,6,15,280050,0],
  [27,0,9,7,130690,0],
  [27,0,10,12,224040,0],
  [27,0,14,8,149360,0],
  [27,0,17,5,93350,0],
  [27,0,20,6,112020,0],
  [27,0,21,5,93350,0],
  [27,0,26,5,93350,0],
  [27,0,28,3,56010,0],
  [27,0,37,11,205370,0],
  [27,0,38,12,224040,0],
  [27,0,40,2,37340,0],
  [27,0,47,2,37340,0],
  [27,0,53,5,93350,0],
  [27,0,56,4,74680,0],
  [27,0,62,1,18670,0],
  [27,0,67,1,18670,0],
  [27,0,69,1,18670,0],
  [27,0,70,6,112020,0],
  [27,0,84,1,18670,0],
  [27,1,5,20,373399,0],
  [27,1,7,16,298720,0],
  [27,1,11,5,93350,0],
  [27,1,12,4,74680,0],
  [27,1,18,8,149360,0],
  [27,1,23,11,205370,0],
  [27,1,24,1,18670,0],
  [27,1,25,6,112020,0],
  [27,1,26,11,205370,0],
  [27,1,30,8,149360,0],
  [27,1,31,3,56010,0],
  [27,1,33,21,392069,0],
  [27,1,40,1,18670,0],
  [27,1,41,3,56010,0],
  [27,1,48,2,37340,0],
  [27,1,51,4,74680,0],
  [27,1,63,4,74680,0],
  [27,2,3,3,56010,0],
  [27,2,8,11,205370,0],
  [27,2,13,13,242710,0],
  [27,2,27,6,112020,0],
  [27,2,44,1,18670,0],
  [27,2,46,1,18670,0],
  [27,2,49,10,186700,0],
  [27,2,50,2,37340,0],
  [27,2,57,4,74680,0],
  [27,2,58,4,74680,0],
  [27,2,61,3,56010,0],
  [27,3,19,4,74680,0],
  [27,3,43,4,74680,0],
  [27,3,45,3,56010,0],
  [27,3,88,1,18670,0],
  [27,4,92,1,18670,0],
  [28,0,0,36,672119,0],
  [28,0,4,11,205370,0],
  [28,0,6,19,354729,0],
  [28,0,9,8,149360,0],
  [28,0,10,12,224040,0],
  [28,0,14,4,74680,0],
  [28,0,17,2,37340,0],
  [28,0,20,4,74680,0],
  [28,0,21,5,93350,0],
  [28,0,28,4,74680,0],
  [28,0,38,21,392069,0],
  [28,0,47,4,74680,0],
  [28,0,53,1,18670,0],
  [28,0,54,2,37340,0],
  [28,0,56,5,93350,0],
  [28,0,62,1,18670,0],
  [28,0,67,1,18670,0],
  [28,0,69,5,93350,0],
  [28,0,70,14,261380,0],
  [28,1,5,9,168030,0],
  [28,1,7,14,261380,0],
  [28,1,11,13,242710,0],
  [28,1,12,11,205370,0],
  [28,1,18,10,186700,0],
  [28,1,24,3,56010,0],
  [28,1,25,2,37340,0],
  [28,1,30,26,485419,0],
  [28,1,31,3,56010,0],
  [28,1,33,5,93350,0],
  [28,1,40,1,18670,0],
  [28,1,41,4,74680,0],
  [28,1,51,4,74680,0],
  [28,1,63,4,74680,0],
  [28,1,65,3,56010,0],
  [28,2,2,28,522759,0],
  [28,2,3,27,504089,0],
  [28,2,8,7,130690,0],
  [28,2,13,10,186700,0],
  [28,2,15,2,37340,0],
  [28,2,22,4,74680,0],
  [28,2,26,2,37340,0],
  [28,2,27,5,93350,0],
  [28,2,32,2,37340,0],
  [28,2,44,8,149360,0],
  [28,2,46,1,18670,0],
  [28,2,49,3,56010,0],
  [28,2,50,9,168030,0],
  [28,2,57,2,37340,0],
  [28,2,59,2,37340,0],
  [28,2,60,5,93350,0],
  [28,2,61,2,37340,0],
  [28,2,73,4,74680,0],
  [28,2,75,5,93350,0],
  [28,3,19,12,224040,0],
  [28,3,34,6,112020,0],
  [28,3,43,5,93350,0],
  [28,3,45,3,56010,0],
  [28,3,88,2,37340,0],
  [28,3,90,1,18670,0],
  [28,3,100,1,18670,0],
  [29,0,0,11,205370,0],
  [29,0,4,5,93350,0],
  [29,0,6,4,74680,0],
  [29,0,9,4,74680,0],
  [29,0,10,5,93350,0],
  [29,0,14,10,186700,0],
  [29,0,17,2,37340,0],
  [29,0,20,8,149360,0],
  [29,0,21,7,130690,0],
  [29,0,28,6,112020,0],
  [29,0,37,3,56010,0],
  [29,0,38,17,317389,0],
  [29,0,53,3,56010,0],
  [29,0,56,2,37340,0],
  [29,0,67,1,18670,0],
  [29,0,69,2,37340,0],
  [29,0,70,4,74680,0],
  [29,1,5,18,336059,0],
  [29,1,7,8,149360,0],
  [29,1,11,5,93350,0],
  [29,1,12,4,74680,0],
  [29,1,18,10,186700,0],
  [29,1,23,5,93350,0],
  [29,1,24,5,93350,0],
  [29,1,25,3,56010,0],
  [29,1,26,8,149360,0],
  [29,1,30,18,336059,0],
  [29,1,31,4,74680,0],
  [29,1,33,5,93350,0],
  [29,1,41,1,18670,0],
  [29,1,48,3,56010,0],
  [29,1,51,4,74680,0],
  [29,1,55,2,37340,0],
  [29,1,63,2,37340,0],
  [29,1,65,4,74680,0],
  [29,2,2,10,186700,0],
  [29,2,3,11,205370,0],
  [29,2,8,10,186700,0],
  [29,2,13,9,168030,0],
  [29,2,22,2,37340,0],
  [29,2,26,1,18670,0],
  [29,2,27,4,74680,0],
  [29,2,32,1,18670,0],
  [29,2,40,1,18670,0],
  [29,2,44,4,74680,0],
  [29,2,46,4,74680,0],
  [29,2,50,1,18670,0],
  [29,2,57,1,18670,0],
  [29,2,58,2,37340,0],
  [29,2,59,4,74680,0],
  [29,2,64,4,74680,0],
  [29,2,73,3,56010,0],
  [29,2,76,1,18670,0],
  [29,3,19,4,74680,0],
  [29,3,34,2,37340,0],
  [29,3,43,4,74680,0],
  [29,3,45,6,112020,0],
  [29,3,86,2,37340,0],
  [29,3,91,1,18670,0],
  [30,0,0,9,168030,0],
  [30,0,4,9,168030,0],
  [30,0,6,12,224040,0],
  [30,0,9,7,130690,0],
  [30,0,10,4,74680,0],
  [30,0,16,9,168030,0],
  [30,0,17,4,74680,0],
  [30,0,20,3,56010,0],
  [30,0,21,3,56010,0],
  [30,0,28,7,130690,0],
  [30,0,38,20,373399,0],
  [30,0,40,2,37340,0],
  [30,0,47,4,74680,0],
  [30,0,53,2,37340,0],
  [30,0,62,2,37340,0],
  [30,0,67,2,37340,0],
  [30,0,69,3,56010,0],
  [30,0,70,3,56010,0],
  [30,0,84,1,18670,0],
  [30,1,5,10,186700,0],
  [30,1,7,7,130690,0],
  [30,1,11,10,186700,0],
  [30,1,12,4,74680,0],
  [30,1,18,10,186700,0],
  [30,1,23,3,56010,0],
  [30,1,24,1,18670,0],
  [30,1,25,6,112020,0],
  [30,1,26,2,37340,0],
  [30,1,30,12,224040,0],
  [30,1,31,3,56010,0],
  [30,1,33,7,130690,0],
  [30,1,40,1,18670,0],
  [30,1,41,2,37340,0],
  [30,1,48,1,18670,0],
  [30,1,51,3,56010,0],
  [30,1,55,1,18670,0],
  [30,1,63,3,56010,0],
  [30,1,65,10,186700,0],
  [30,2,2,30,560099,0],
  [30,2,3,11,205370,0],
  [30,2,8,8,149360,0],
  [30,2,13,11,205370,0],
  [30,2,27,4,74680,0],
  [30,2,32,4,74680,0],
  [30,2,44,3,56010,0],
  [30,2,46,4,74680,0],
  [30,2,49,3,56010,0],
  [30,2,52,4,74680,0],
  [30,2,57,4,74680,0],
  [30,2,58,2,37340,0],
  [30,2,60,5,93350,0],
  [30,2,61,3,56010,0],
  [30,2,64,3,56010,0],
  [30,2,75,2,37340,0],
  [30,3,19,4,74680,0],
  [30,4,82,3,56010,0],
  [31,0,0,48,896159,0],
  [31,0,4,10,186700,0],
  [31,0,6,6,112020,0],
  [31,0,9,7,130690,0],
  [31,0,10,9,168030,0],
  [31,0,14,5,93350,0],
  [31,0,20,3,56010,0],
  [31,0,21,4,74680,0],
  [31,0,26,7,130690,0],
  [31,0,28,5,93350,0],
  [31,0,37,10,186700,0],
  [31,0,38,16,298720,0],
  [31,0,40,1,18670,0],
  [31,0,53,3,56010,0],
  [31,0,56,5,93350,0],
  [31,0,67,2,37340,0],
  [31,0,69,3,56010,0],
  [31,0,70,3,56010,0],
  [31,1,5,16,298720,0],
  [31,1,7,14,261380,0],
  [31,1,11,7,130690,0],
  [31,1,12,7,130690,0],
  [31,1,18,7,130690,0],
  [31,1,23,3,56010,0],
  [31,1,24,3,56010,0],
  [31,1,25,8,149360,0],
  [31,1,26,7,130690,0],
  [31,1,30,6,112020,0],
  [31,1,31,3,56010,0],
  [31,1,33,12,224040,0],
  [31,1,40,4,74680,0],
  [31,1,41,5,93350,0],
  [31,1,42,2,37340,0],
  [31,1,48,1,18670,0],
  [31,1,51,2,37340,0],
  [31,1,55,2,37340,0],
  [31,1,63,2,37340,0],
  [31,1,65,6,112020,0],
  [31,2,3,11,205370,0],
  [31,2,13,8,149360,0],
  [31,2,22,3,56010,0],
  [31,2,26,2,37340,0],
  [31,2,27,4,74680,0],
  [31,2,44,4,74680,0],
  [31,2,46,1,18670,0],
  [31,2,49,4,74680,0],
  [31,2,50,12,224040,0],
  [31,2,52,4,74680,0],
  [31,2,57,2,37340,0],
  [31,2,58,2,37340,0],
  [31,2,61,3,56010,0],
  [31,2,73,1,18670,0],
  [31,3,19,4,74680,0],
  [31,3,43,2,37340,0],
  [31,3,45,3,56010,0],
  [31,3,95,2,37340,0],
  [31,4,92,2,37340,0],
  [32,0,0,26,485419,0],
  [32,0,4,6,112020,0],
  [32,0,6,21,392069,0],
  [32,0,9,7,130690,0],
  [32,0,10,11,205370,0],
  [32,0,14,12,224040,0],
  [32,0,17,6,112020,0],
  [32,0,20,9,168030,0],
  [32,0,21,5,93350,0],
  [32,0,28,2,37340,0],
  [32,0,37,2,37340,0],
  [32,0,38,27,504089,0],
  [32,0,40,2,37340,0],
  [32,0,47,2,37340,0],
  [32,0,53,2,37340,0],
  [32,0,56,2,37340,0],
  [32,0,69,4,74680,0],
  [32,0,70,11,205370,0],
  [32,0,84,4,74680,0],
  [32,1,5,10,186700,0],
  [32,1,7,17,317389,0],
  [32,1,11,10,186700,0],
  [32,1,12,8,149360,0],
  [32,1,18,14,261380,0],
  [32,1,24,5,93350,0],
  [32,1,25,3,56010,0],
  [32,1,30,12,224040,0],
  [32,1,31,5,93350,0],
  [32,1,33,10,186700,0],
  [32,1,41,5,93350,0],
  [32,1,48,2,37340,0],
  [32,1,51,8,149360,0],
  [32,1,63,3,56010,0],
  [32,2,2,26,485419,0],
  [32,2,3,11,205370,0],
  [32,2,8,8,149360,0],
  [32,2,13,22,410739,0],
  [32,2,22,3,56010,0],
  [32,2,27,9,168030,0],
  [32,2,32,4,74680,0],
  [32,2,44,2,37340,0],
  [32,2,46,1,18670,0],
  [32,2,49,7,130690,0],
  [32,2,50,3,56010,0],
  [32,2,57,4,74680,0],
  [32,2,59,3,56010,0],
  [32,2,61,3,56010,0],
  [32,2,73,1,18670,0],
  [32,2,74,1,18670,0],
  [32,2,75,3,56010,0],
  [32,3,19,6,112020,0],
  [32,3,34,3,56010,0],
  [32,3,43,7,130690,0],
  [32,3,45,3,56010,0],
  [32,3,79,1,18670,0],
  [32,3,86,1,18670,0],
  [32,3,88,1,18670,0],
  [32,3,100,1,18670,0],
  [33,0,0,1,18670,0],
  [33,0,4,16,298720,0],
  [33,0,6,12,224040,0],
  [33,0,9,4,74680,0],
  [33,0,10,7,130690,0],
  [33,0,14,5,93350,0],
  [33,0,16,8,149360,0],
  [33,0,17,7,130690,0],
  [33,0,20,12,224040,0],
  [33,0,21,5,93350,0],
  [33,0,28,9,168030,0],
  [33,0,37,5,93350,0],
  [33,0,38,16,298720,0],
  [33,0,40,3,56010,0],
  [33,0,47,4,74680,0],
  [33,0,53,1,18670,0],
  [33,0,54,1,18670,0],
  [33,0,56,1,18670,0],
  [33,0,62,2,37340,0],
  [33,0,69,3,56010,0],
  [33,0,70,6,112020,0],
  [33,1,5,21,392069,0],
  [33,1,7,15,280050,0],
  [33,1,11,12,224040,0],
  [33,1,12,10,186700,0],
  [33,1,15,2,37340,0],
  [33,1,18,3,56010,0],
  [33,1,23,5,93350,0],
  [33,1,24,5,93350,0],
  [33,1,25,6,112020,0],
  [33,1,26,3,56010,0],
  [33,1,30,24,448079,0],
  [33,1,31,6,112020,0],
  [33,1,33,11,205370,0],
  [33,1,40,36,672119,0],
  [33,1,41,3,56010,0],
  [33,1,48,1,18670,0],
  [33,1,51,3,56010,0],
  [33,1,63,3,56010,0],
  [33,2,2,8,149360,0],
  [33,2,3,17,317389,0],
  [33,2,8,9,168030,0],
  [33,2,13,2,37340,0],
  [33,2,26,5,93350,0],
  [33,2,27,10,186700,0],
  [33,2,32,7,130690,0],
  [33,2,44,4,74680,0],
  [33,2,46,2,37340,0],
  [33,2,49,2,37340,0],
  [33,2,50,4,74680,0],
  [33,2,57,1,18670,0],
  [33,2,59,2,37340,0],
  [33,2,60,5,93350,0],
  [33,2,64,3,56010,0],
  [33,2,73,2,37340,0],
  [33,3,19,12,224040,0],
  [33,3,34,5,93350,0],
  [33,3,45,6,112020,0],
  [33,3,88,1,18670,0],
  [33,3,91,1,18670,0],
  [33,4,105,3,56010,0],
  [34,0,0,25,466749,0],
  [34,0,6,5,93350,0],
  [34,0,10,4,74680,0],
  [34,0,20,3,56010,0],
  [34,0,21,6,112020,0],
  [34,0,28,6,112020,0],
  [34,0,37,5,93350,0],
  [34,0,38,24,448079,0],
  [34,0,53,1,18670,0],
  [34,0,54,1,18670,0],
  [34,0,56,2,37340,0],
  [34,0,67,7,130690,0],
  [34,0,69,3,56010,0],
  [34,0,70,6,112020,0],
  [34,1,5,8,149360,0],
  [34,1,7,7,130690,0],
  [34,1,11,12,224040,0],
  [34,1,12,3,56010,0],
  [34,1,15,5,93350,0],
  [34,1,18,13,242710,0],
  [34,1,23,4,74680,0],
  [34,1,25,7,130690,0],
  [34,1,26,3,56010,0],
  [34,1,30,24,448079,0],
  [34,1,31,3,56010,0],
  [34,1,33,10,186700,0],
  [34,1,41,4,74680,0],
  [34,1,48,3,56010,0],
  [34,1,51,5,93350,0],
  [34,1,63,4,74680,0],
  [34,1,65,12,224040,0],
  [34,2,2,8,149360,0],
  [34,2,3,7,130690,0],
  [34,2,13,7,130690,0],
  [34,2,32,4,74680,0],
  [34,2,40,1,18670,0],
  [34,2,44,6,112020,0],
  [34,2,46,1,18670,0],
  [34,2,49,3,56010,0],
  [34,2,50,3,56010,0],
  [34,2,57,2,37340,0],
  [34,2,58,2,37340,0],
  [34,2,61,3,56010,0],
  [34,2,64,5,93350,0],
  [34,2,73,1,18670,0],
  [34,2,75,2,37340,0],
  [34,2,76,1,18670,0],
  [34,3,19,6,112020,0],
  [34,3,34,1,18670,0],
  [34,3,86,1,18670,0],
  [34,3,90,1,18670,0],
  [34,4,82,3,56010,0],
  [35,0,0,26,485419,0],
  [35,0,4,18,336059,0],
  [35,0,6,11,205370,0],
  [35,0,9,9,168030,0],
  [35,0,10,15,280050,0],
  [35,0,14,5,93350,0],
  [35,0,16,12,224040,0],
  [35,0,17,6,112020,0],
  [35,0,20,2,37340,0],
  [35,0,21,4,74680,0],
  [35,0,26,3,56010,0],
  [35,0,28,1,18670,0],
  [35,0,37,4,74680,0],
  [35,0,38,23,429409,0],
  [35,0,47,4,74680,0],
  [35,0,53,1,18670,0],
  [35,0,54,1,18670,0],
  [35,0,56,5,93350,0],
  [35,0,67,4,74680,0],
  [35,0,69,2,37340,0],
  [35,0,70,4,74680,0],
  [35,1,5,17,317389,0],
  [35,1,7,8,149360,0],
  [35,1,11,7,130690,0],
  [35,1,12,6,112020,0],
  [35,1,15,2,37340,0],
  [35,1,18,10,186700,0],
  [35,1,24,3,56010,0],
  [35,1,25,8,149360,0],
  [35,1,26,3,56010,0],
  [35,1,30,16,298720,0],
  [35,1,31,3,56010,0],
  [35,1,33,10,186700,0],
  [35,1,40,5,93350,0],
  [35,1,41,12,224040,0],
  [35,1,48,1,18670,0],
  [35,1,55,4,74680,0],
  [35,1,63,1,18670,0],
  [35,1,65,6,112020,0],
  [35,2,2,8,149360,0],
  [35,2,3,20,373399,0],
  [35,2,8,7,130690,0],
  [35,2,13,7,130690,0],
  [35,2,22,4,74680,0],
  [35,2,27,3,56010,0],
  [35,2,44,4,74680,0],
  [35,2,46,2,37340,0],
  [35,2,49,5,93350,0],
  [35,2,50,7,130690,0],
  [35,2,52,1,18670,0],
  [35,2,57,4,74680,0],
  [35,2,58,4,74680,0],
  [35,2,60,5,93350,0],
  [35,2,61,4,74680,0],
  [35,2,73,1,18670,0],
  [35,2,75,4,74680,0],
  [35,3,43,4,74680,0],
  [35,3,45,4,74680,0],
  [35,3,83,1,18670,0],
  [35,3,86,2,37340,0],
  [35,3,106,1,18670,0],
  [35,4,92,1,18670,0],
  [36,0,0,26,485419,0],
  [36,0,4,6,112020,0],
  [36,0,6,15,280050,0],
  [36,0,9,13,242710,0],
  [36,0,10,5,93350,0],
  [36,0,14,6,112020,0],
  [36,0,17,1,18670,0],
  [36,0,20,7,130690,0],
  [36,0,21,8,149360,0],
  [36,0,26,3,56010,0],
  [36,0,28,5,93350,0],
  [36,0,37,8,149360,0],
  [36,0,38,27,504089,0],
  [36,0,40,4,74680,0],
  [36,0,53,4,74680,0],
  [36,0,54,2,37340,0],
  [36,0,62,2,37340,0],
  [36,0,67,1,18670,0],
  [36,0,69,6,112020,0],
  [36,0,70,3,56010,0],
  [36,1,5,17,317389,0],
  [36,1,7,23,429409,0],
  [36,1,11,8,149360,0],
  [36,1,12,2,37340,0],
  [36,1,15,4,74680,0],
  [36,1,18,11,205370,0],
  [36,1,23,5,93350,0],
  [36,1,24,1,18670,0],
  [36,1,25,4,74680,0],
  [36,1,26,11,205370,0],
  [36,1,30,16,298720,0],
  [36,1,31,3,56010,0],
  [36,1,33,9,168030,0],
  [36,1,41,6,112020,0],
  [36,1,51,4,74680,0],
  [36,1,55,2,37340,0],
  [36,1,63,2,37340,0],
  [36,1,65,5,93350,0],
  [36,2,2,22,410739,0],
  [36,2,3,18,336059,0],
  [36,2,8,15,280050,0],
  [36,2,13,15,280050,0],
  [36,2,27,6,112020,0],
  [36,2,32,1,18670,0],
  [36,2,44,5,93350,0],
  [36,2,49,6,112020,0],
  [36,2,50,2,37340,0],
  [36,2,52,4,74680,0],
  [36,2,58,2,37340,0],
  [36,2,59,2,37340,0],
  [36,2,61,3,56010,0],
  [36,2,64,2,37340,0],
  [36,2,73,3,56010,0],
  [36,2,75,1,18670,0],
  [36,3,19,9,168030,0],
  [36,3,34,1,18670,0],
  [36,3,43,1,18670,0],
  [36,3,45,4,74680,0],
  [36,3,79,1,18670,0],
  [36,3,95,2,37340,0],
  [36,4,92,1,18670,0],
  [37,0,4,6,112020,0],
  [37,0,6,9,168030,0],
  [37,0,9,7,130690,0],
  [37,0,10,7,130690,0],
  [37,0,14,17,317389,0],
  [37,0,17,4,74680,0],
  [37,0,20,7,130690,0],
  [37,0,21,10,186700,0],
  [37,0,26,2,37340,0],
  [37,0,28,6,112020,0],
  [37,0,38,32,597439,1],
  [37,0,47,4,74680,0],
  [37,0,53,2,37340,0],
  [37,0,69,5,93350,0],
  [37,0,70,10,186700,0],
  [37,1,5,11,205370,0],
  [37,1,7,14,261380,0],
  [37,1,11,16,298720,0],
  [37,1,12,6,112020,0],
  [37,1,15,1,18670,0],
  [37,1,18,12,224040,0],
  [37,1,23,6,112020,0],
  [37,1,24,7,130690,0],
  [37,1,25,9,168030,0],
  [37,1,30,22,410739,0],
  [37,1,31,4,74680,0],
  [37,1,33,13,242710,0],
  [37,1,40,1,18670,0],
  [37,1,41,7,130690,0],
  [37,1,48,5,93350,0],
  [37,1,51,6,112020,0],
  [37,1,55,2,37340,0],
  [37,1,63,3,56010,0],
  [37,1,65,3,56010,0],
  [37,2,2,18,336059,0],
  [37,2,3,20,373399,0],
  [37,2,8,8,149360,0],
  [37,2,13,10,186700,0],
  [37,2,22,2,37340,0],
  [37,2,26,2,37340,0],
  [37,2,27,9,168030,0],
  [37,2,32,2,37340,0],
  [37,2,44,3,56010,0],
  [37,2,46,1,18670,0],
  [37,2,49,1,18670,0],
  [37,2,50,3,56010,0],
  [37,2,52,3,56010,0],
  [37,2,57,5,93350,0],
  [37,2,59,2,37340,0],
  [37,2,64,7,130690,0],
  [37,2,73,3,56010,0],
  [37,3,19,6,112020,0],
  [37,3,34,7,130690,0],
  [37,3,43,4,74680,0],
  [37,3,91,1,18670,0],
  [37,3,100,1,18670,0],
  [38,0,0,24,448079,0],
  [38,0,4,14,261380,0],
  [38,0,6,6,112020,0],
  [38,0,10,9,168030,0],
  [38,0,14,1,18670,0],
  [38,0,17,3,56010,0],
  [38,0,21,5,93350,0],
  [38,0,26,4,74680,0],
  [38,0,28,6,112020,0],
  [38,0,38,19,354729,1],
  [38,0,47,2,37340,0],
  [38,0,53,1,18670,0],
  [38,0,54,1,18670,0],
  [38,0,56,2,37340,0],
  [38,0,70,6,112020,0],
  [38,0,82,3,56010,0],
  [38,0,84,1,18670,0],
  [38,1,5,9,168030,0],
  [38,1,11,5,93350,0],
  [38,1,12,3,56010,0],
  [38,1,15,3,56010,0],
  [38,1,18,4,74680,0],
  [38,1,23,5,93350,0],
  [38,1,24,4,74680,0],
  [38,1,25,3,56010,0],
  [38,1,26,17,317389,0],
  [38,1,30,20,373399,0],
  [38,1,31,10,186700,0],
  [38,1,33,5,93350,0],
  [38,1,40,1,18670,0],
  [38,1,41,3,56010,0],
  [38,1,55,2,37340,0],
  [38,1,63,5,93350,0],
  [38,1,65,8,149360,0],
  [38,2,2,10,186700,0],
  [38,2,3,18,336059,0],
  [38,2,8,5,93350,0],
  [38,2,13,7,130690,0],
  [38,2,26,3,56010,0],
  [38,2,27,5,93350,0],
  [38,2,40,1,18670,0],
  [38,2,46,2,37340,0],
  [38,2,49,7,130690,0],
  [38,2,50,3,56010,0],
  [38,2,57,1,18670,0],
  [38,2,59,1,18670,0],
  [38,2,61,4,74680,0],
  [38,2,64,3,56010,0],
  [38,3,34,1,18670,0],
  [38,3,45,5,93350,0],
  [38,4,82,2,37340,0],
  [39,0,0,30,569061,0],
  [39,0,4,6,113887,0],
  [39,0,6,4,74680,0],
  [39,0,9,6,113140,0],
  [39,0,10,13,244950,0],
  [39,0,14,1,18670,0],
  [39,0,17,3,56010,0],
  [39,0,20,7,132183,0],
  [39,0,21,2,37340,0],
  [39,0,28,4,75053,0],
  [39,0,37,6,112020,0],
  [39,0,38,24,449573,0],
  [39,0,54,1,18670,0],
  [39,0,56,3,56757,0],
  [39,0,67,1,18670,0],
  [39,0,82,1,18670,0],
  [39,0,84,2,37340,0],
  [39,1,5,3,56010,0],
  [39,1,7,9,168030,0],
  [39,1,11,1,18670,0],
  [39,1,12,10,189687,0],
  [39,1,15,9,168030,0],
  [39,1,18,18,336059,0],
  [39,1,23,5,95217,0],
  [39,1,25,6,112020,0],
  [39,1,30,6,112020,0],
  [39,1,31,2,37340,0],
  [39,1,33,10,187447,0],
  [39,1,40,4,74680,0],
  [39,1,41,6,112020,0],
  [39,1,63,4,75053,0],
  [39,2,2,15,280050,0],
  [39,2,3,15,281917,0],
  [39,2,13,8,151227,0],
  [39,2,22,4,76174,0],
  [39,2,27,1,19043,0],
  [39,2,32,2,38087,0],
  [39,2,44,8,150853,0],
  [39,2,46,6,112767,0],
  [39,2,49,7,131437,0],
  [39,2,50,6,112393,0],
  [39,2,57,3,56010,0],
  [39,2,58,6,112767,0],
  [39,2,61,2,38087,0],
  [39,2,75,2,38087,0],
  [39,3,19,5,93350,0],
  [39,3,43,1,19043,0],
  [39,3,45,15,280050,0],
  [39,3,90,1,18670,0],
  [40,0,4,17,323737,0],
  [40,0,6,10,190434,0],
  [40,0,9,8,152347,0],
  [40,0,10,6,114260,0],
  [40,0,14,7,133304,0],
  [40,0,16,8,152347,0],
  [40,0,17,5,95217,0],
  [40,0,20,4,76174,0],
  [40,0,21,2,38087,0],
  [40,0,26,5,95217,0],
  [40,0,28,6,114260,0],
  [40,0,37,8,152347,0],
  [40,0,38,19,361824,1],
  [40,0,47,2,38087,0],
  [40,0,53,2,38087,0],
  [40,0,54,2,38087,0],
  [40,0,62,1,19043,0],
  [40,0,67,1,19043,0],
  [40,0,69,4,76174,0],
  [40,0,70,8,152347,0],
  [40,1,5,27,514171,0],
  [40,1,7,14,266607,0],
  [40,1,11,11,209477,0],
  [40,1,12,5,95217,0],
  [40,1,15,2,38087,0],
  [40,1,23,3,57130,0],
  [40,1,25,10,190434,0],
  [40,1,26,15,285651,0],
  [40,1,30,12,228521,0],
  [40,1,31,4,76174,0],
  [40,1,33,9,171390,0],
  [40,1,40,2,38087,0],
  [40,1,41,7,133304,0],
  [40,1,48,3,57130,0],
  [40,1,51,2,38087,0],
  [40,1,55,2,38087,0],
  [40,1,63,3,57130,0],
  [40,1,65,9,171390,0],
  [40,2,2,10,190434,0],
  [40,2,3,12,228521,0],
  [40,2,8,11,209477,0],
  [40,2,13,9,171390,0],
  [40,2,32,4,76174,0],
  [40,2,44,2,38087,0],
  [40,2,46,2,38087,0],
  [40,2,50,2,38087,0],
  [40,2,52,2,38087,0],
  [40,2,57,4,76174,0],
  [40,2,60,5,95217,0],
  [40,2,64,2,38087,0],
  [40,2,75,5,95217,0],
  [40,3,19,6,114260,0],
  [40,3,34,2,38087,0],
  [40,3,43,4,76174,0],
  [40,3,79,1,19043,0],
  [40,3,106,1,19043,0],
  [40,4,92,2,38087,0],
  [41,0,0,26,495128,0],
  [41,0,4,13,247564,0],
  [41,0,6,9,171390,0],
  [41,0,9,5,95217,0],
  [41,0,10,2,38087,0],
  [41,0,14,2,38087,0],
  [41,0,20,9,171390,0],
  [41,0,21,4,76174,0],
  [41,0,26,1,19043,0],
  [41,0,28,5,95217,0],
  [41,0,38,18,342781,0],
  [41,0,47,2,38087,0],
  [41,0,53,3,57130,0],
  [41,0,54,2,38087,0],
  [41,0,56,2,38087,0],
  [41,0,62,1,19043,0],
  [41,0,69,3,57130,0],
  [41,1,5,15,285651,0],
  [41,1,7,15,285651,0],
  [41,1,11,23,437998,0],
  [41,1,12,3,57130,0],
  [41,1,15,3,57130,0],
  [41,1,18,7,133304,0],
  [41,1,25,4,76174,0],
  [41,1,30,24,457041,0],
  [41,1,31,4,76174,0],
  [41,1,33,18,342781,0],
  [41,1,41,4,76174,0],
  [41,1,48,3,57130,0],
  [41,1,51,5,95217,0],
  [41,2,2,22,418954,0],
  [41,2,3,14,266607,0],
  [41,2,8,7,133304,0],
  [41,2,13,11,209477,0],
  [41,2,32,3,57130,0],
  [41,2,44,2,38087,0],
  [41,2,46,1,19043,0],
  [41,2,49,1,19043,0],
  [41,2,50,4,76174,0],
  [41,2,52,1,19043,0],
  [41,2,59,2,38087,0],
  [41,2,64,2,38087,0],
  [41,3,19,6,114260,0],
  [41,3,34,3,57130,0],
  [41,3,43,2,38087,0],
  [41,3,86,1,19043,0],
  [41,3,88,2,38087,0],
  [41,3,106,1,19043,0],
  [41,4,82,1,19043,0],
  [42,0,4,7,133304,0],
  [42,0,6,5,95217,0],
  [42,0,9,8,152347,0],
  [42,0,10,12,228521,0],
  [42,0,14,15,285651,0],
  [42,0,17,5,95217,0],
  [42,0,21,7,133304,0],
  [42,0,28,8,152347,0],
  [42,0,37,3,57130,0],
  [42,0,38,26,495128,0],
  [42,0,47,1,19043,0],
  [42,0,53,2,38087,0],
  [42,0,54,1,19043,0],
  [42,0,56,5,95217,0],
  [42,0,62,3,57130,0],
  [42,0,69,3,57130,0],
  [42,0,70,4,76174,0],
  [42,1,5,28,533215,0],
  [42,1,7,18,342781,0],
  [42,1,11,2,38087,0],
  [42,1,12,7,133304,0],
  [42,1,15,1,19043,0],
  [42,1,18,13,247564,0],
  [42,1,23,6,114260,0],
  [42,1,25,4,76174,0],
  [42,1,26,15,285651,0],
  [42,1,30,14,266607,0],
  [42,1,31,6,114260,0],
  [42,1,33,5,95217,0],
  [42,1,40,2,38087,0],
  [42,1,41,5,95217,0],
  [42,1,48,3,57130,0],
  [42,1,51,1,19043,0],
  [42,1,63,6,114260,0],
  [42,1,65,8,152347,0],
  [42,2,2,10,190434,0],
  [42,2,3,15,285651,0],
  [42,2,8,9,171390,0],
  [42,2,13,8,152347,0],
  [42,2,26,1,19043,0],
  [42,2,32,2,38087,0],
  [42,2,44,1,19043,0],
  [42,2,46,1,19043,0],
  [42,2,49,10,190434,0],
  [42,2,50,2,38087,0],
  [42,2,58,2,38087,0],
  [42,2,59,1,19043,0],
  [42,2,61,4,76174,0],
  [42,3,34,6,114260,0],
  [42,3,91,1,19043,0],
  [43,0,0,9,171390,0],
  [43,0,4,3,57130,0],
  [43,0,6,8,152347,0],
  [43,0,9,4,76174,0],
  [43,0,10,10,190434,0],
  [43,0,14,4,76174,0],
  [43,0,16,8,152347,0],
  [43,0,17,2,38087,0],
  [43,0,20,3,57130,0],
  [43,0,21,7,133304,0],
  [43,0,37,3,57130,0],
  [43,0,38,24,457041,0],
  [43,0,47,2,38087,0],
  [43,0,56,1,19043,0],
  [43,0,67,2,38087,0],
  [43,0,69,3,57130,0],
  [43,1,5,7,133304,0],
  [43,1,11,6,114260,0],
  [43,1,12,6,114260,0],
  [43,1,15,5,95217,0],
  [43,1,18,9,171390,0],
  [43,1,25,7,133304,0],
  [43,1,26,2,38087,0],
  [43,1,30,17,323737,0],
  [43,1,31,8,152347,0],
  [43,1,33,13,247564,0],
  [43,1,40,2,38087,0],
  [43,1,41,6,114260,0],
  [43,1,48,1,19043,0],
  [43,1,51,2,38087,0],
  [43,2,2,8,152347,0],
  [43,2,3,5,95217,0],
  [43,2,13,10,190434,0],
  [43,2,22,4,76174,0],
  [43,2,32,1,19043,0],
  [43,2,44,4,76174,0],
  [43,2,46,3,57130,0],
  [43,2,49,3,57130,0],
  [43,2,50,5,95217,0],
  [43,2,57,4,76174,0],
  [43,2,58,2,38087,0],
  [43,2,59,2,38087,0],
  [43,2,61,2,38087,0],
  [43,2,64,2,38087,0],
  [43,2,73,4,76174,0],
  [43,3,19,6,114260,0],
  [43,3,43,2,38087,0],
  [43,3,88,2,38087,0],
  [44,0,0,24,457041,0],
  [44,0,4,14,266607,0],
  [44,0,6,12,228521,0],
  [44,0,9,7,133304,0],
  [44,0,10,7,133304,0],
  [44,0,14,9,171390,0],
  [44,0,16,8,152347,0],
  [44,0,17,3,57130,0],
  [44,0,20,14,266607,0],
  [44,0,21,6,114260,0],
  [44,0,26,5,95217,0],
  [44,0,28,2,38087,0],
  [44,0,37,6,114260,0],
  [44,0,38,23,437998,0],
  [44,0,47,1,19043,0],
  [44,0,53,3,57130,0],
  [44,0,54,1,19043,0],
  [44,0,56,2,38087,0],
  [44,0,67,5,95217,0],
  [44,0,69,11,209477,0],
  [44,0,70,8,152347,0],
  [44,1,5,25,476085,0],
  [44,1,11,7,133304,0],
  [44,1,12,7,133304,0],
  [44,1,15,6,114260,0],
  [44,1,18,6,114260,0],
  [44,1,23,6,114260,0],
  [44,1,25,5,95217,0],
  [44,1,26,1,19043,0],
  [44,1,30,16,304694,0],
  [44,1,31,3,57130,0],
  [44,1,33,5,95217,0],
  [44,1,40,1,19043,0],
  [44,1,51,1,19043,0],
  [44,1,55,3,57130,0],
  [44,1,65,10,190434,0],
  [44,2,2,22,418954,0],
  [44,2,3,18,342781,0],
  [44,2,8,7,133304,0],
  [44,2,13,8,152347,0],
  [44,2,26,2,38087,0],
  [44,2,32,3,57130,0],
  [44,2,44,4,76174,0],
  [44,2,46,4,76174,0],
  [44,2,50,4,76174,0],
  [44,2,52,3,57130,0],
  [44,2,57,3,57130,0],
  [44,2,58,2,38087,0],
  [44,2,60,4,76174,0],
  [44,2,64,3,57130,0],
  [44,2,73,3,57130,0],
  [44,2,75,3,57130,0],
  [44,3,34,5,95217,0],
  [44,3,43,2,38087,0],
  [44,3,79,1,19043,0],
  [44,3,86,2,38087,0],
  [45,0,0,24,457041,0],
  [45,0,4,17,323737,0],
  [45,0,6,15,285651,0],
  [45,0,9,3,57130,0],
  [45,0,10,8,152347,0],
  [45,0,17,2,38087,0],
  [45,0,20,5,95217,0],
  [45,0,21,6,114260,0],
  [45,0,26,1,19043,0],
  [45,0,28,2,38087,0],
  [45,0,37,2,38087,0],
  [45,0,38,17,323737,0],
  [45,0,40,1,19043,0],
  [45,0,47,5,95217,0],
  [45,0,53,1,19043,0],
  [45,0,54,2,38087,0],
  [45,0,56,1,19043,0],
  [45,0,62,1,19043,0],
  [45,0,69,2,38087,0],
  [45,1,5,15,285651,0],
  [45,1,7,21,399911,0],
  [45,1,11,9,171390,0],
  [45,1,12,2,38087,0],
  [45,1,15,3,57130,0],
  [45,1,18,14,266607,0],
  [45,1,23,5,95217,0],
  [45,1,25,9,171390,0],
  [45,1,26,15,285651,0],
  [45,1,30,23,437998,0],
  [45,1,33,11,209477,0],
  [45,1,41,5,95217,0],
  [45,1,48,2,38087,0],
  [45,1,51,3,57130,0],
  [45,1,65,7,133304,0],
  [45,2,2,10,190434,0],
  [45,2,3,20,380868,0],
  [45,2,8,9,171390,0],
  [45,2,13,8,152347,0],
  [45,2,32,2,38087,0],
  [45,2,44,1,19043,0],
  [45,2,49,2,38087,0],
  [45,2,50,6,114260,0],
  [45,2,52,2,38087,0],
  [45,2,57,5,95217,0],
  [45,2,64,2,38087,0],
  [45,2,73,1,19043,0],
  [45,2,75,2,38087,0],
  [45,3,34,1,19043,0],
  [45,3,43,1,19043,0],
  [45,3,45,4,76174,0],
  [45,3,86,2,38087,0],
  [45,3,88,1,19043,0],
  [45,3,89,12,228521,0],
  [45,3,90,1,19043,0],
  [45,4,82,1,19043,0],
  [45,4,92,2,38087,0],
  [46,0,0,26,495128,0],
  [46,0,4,5,95217,0],
  [46,0,6,8,152347,0],
  [46,0,9,3,57130,0],
  [46,0,10,7,133304,0],
  [46,0,14,6,114260,0],
  [46,0,17,4,76174,0],
  [46,0,20,5,95217,0],
  [46,0,21,6,114260,0],
  [46,0,26,2,38087,0],
  [46,0,28,8,152347,0],
  [46,0,37,4,76174,0],
  [46,0,38,22,418954,0],
  [46,0,54,1,19043,0],
  [46,0,56,3,57130,0],
  [46,0,62,1,19043,0],
  [46,0,69,4,76174,0],
  [46,0,70,4,76174,0],
  [46,1,5,12,228521,0],
  [46,1,7,6,114260,0],
  [46,1,11,15,285651,0],
  [46,1,12,4,76174,0],
  [46,1,15,2,38087,0],
  [46,1,18,9,171390,0],
  [46,1,25,6,114260,0],
  [46,1,26,3,57130,0],
  [46,1,30,21,399911,0],
  [46,1,31,9,171390,0],
  [46,1,33,13,247564,0],
  [46,1,40,1,19043,0],
  [46,1,41,7,133304,0],
  [46,1,48,3,57130,0],
  [46,1,51,3,57130,0],
  [46,1,65,1,19043,0],
  [46,2,2,6,114260,0],
  [46,2,3,17,323737,0],
  [46,2,8,8,152347,0],
  [46,2,13,8,152347,0],
  [46,2,22,3,57130,0],
  [46,2,26,3,57130,0],
  [46,2,44,4,76174,0],
  [46,2,46,4,76174,0],
  [46,2,49,4,76174,0],
  [46,2,52,1,19043,0],
  [46,2,61,2,38087,0],
  [46,2,75,2,38087,0],
  [46,3,34,7,133304,0],
  [46,3,43,9,171390,0],
  [46,3,45,4,76174,0],
  [47,0,4,1,19043,0],
  [47,0,6,14,266607,0],
  [47,0,9,7,133304,0],
  [47,0,10,7,133304,0],
  [47,0,17,2,38087,0],
  [47,0,20,5,95217,0],
  [47,0,21,6,114260,0],
  [47,0,28,1,19043,0],
  [47,0,37,4,76174,0],
  [47,0,38,24,457041,0],
  [47,0,47,2,38087,0],
  [47,0,53,1,19043,0],
  [47,0,56,1,19043,0],
  [47,0,62,4,76174,0],
  [47,0,67,3,57130,0],
  [47,0,69,4,76174,0],
  [47,0,70,5,95217,0],
  [47,1,5,10,190434,0],
  [47,1,7,14,266607,0],
  [47,1,11,10,190434,0],
  [47,1,12,6,114260,0],
  [47,1,15,2,38087,0],
  [47,1,18,12,228521,0],
  [47,1,23,4,76174,0],
  [47,1,25,6,114260,0],
  [47,1,26,9,171390,0],
  [47,1,30,16,304694,0],
  [47,1,31,4,76174,0],
  [47,1,33,13,247564,0],
  [47,1,40,7,133304,0],
  [47,1,41,11,209477,0],
  [47,1,48,1,19043,0],
  [47,1,51,2,38087,0],
  [47,1,55,3,57130,0],
  [47,1,65,6,114260,0],
  [47,2,2,16,304694,0],
  [47,2,3,9,171390,0],
  [47,2,8,8,152347,0],
  [47,2,13,13,247564,0],
  [47,2,22,2,38087,0],
  [47,2,32,3,57130,0],
  [47,2,40,1,19043,0],
  [47,2,44,1,19043,0],
  [47,2,46,4,76174,0],
  [47,2,49,1,19043,0],
  [47,2,52,4,76174,0],
  [47,2,57,1,19043,0],
  [47,2,58,2,38087,0],
  [47,2,59,2,38087,0],
  [47,2,64,5,95217,0],
  [47,2,73,2,38087,0],
  [47,3,34,3,57130,0],
  [47,3,91,1,19043,0],
  [47,3,95,2,38087,0],
  [47,4,82,2,38087,0],
  [48,0,0,27,514171,0],
  [48,0,4,13,247564,0],
  [48,0,6,6,114260,0],
  [48,0,9,7,133304,0],
  [48,0,10,6,114260,0],
  [48,0,14,5,95217,0],
  [48,0,16,8,152347,0],
  [48,0,20,5,95217,0],
  [48,0,21,3,57130,0],
  [48,0,26,3,57130,0],
  [48,0,28,5,95217,0],
  [48,0,37,4,76174,0],
  [48,0,38,21,399911,0],
  [48,0,40,1,19043,0],
  [48,0,47,1,19043,0],
  [48,0,53,2,38087,0],
  [48,0,54,1,19043,0],
  [48,0,56,2,38087,0],
  [48,0,67,3,57130,0],
  [48,0,69,6,114260,0],
  [48,0,84,1,19043,0],
  [48,1,5,23,437998,0],
  [48,1,7,17,323737,0],
  [48,1,11,5,95217,0],
  [48,1,12,2,38087,0],
  [48,1,15,7,133304,0],
  [48,1,18,8,152347,0],
  [48,1,23,5,95217,0],
  [48,1,25,4,76174,0],
  [48,1,26,14,266607,0],
  [48,1,30,12,228521,0],
  [48,1,31,4,76174,0],
  [48,1,33,10,190434,0],
  [48,1,41,6,114260,0],
  [48,1,51,2,38087,0],
  [48,1,65,8,152347,0],
  [48,2,3,15,285651,0],
  [48,2,13,10,190434,0],
  [48,2,26,1,19043,0],
  [48,2,32,6,114260,0],
  [48,2,44,3,57130,0],
  [48,2,46,2,38087,0],
  [48,2,49,4,76174,0],
  [48,2,50,6,114260,0],
  [48,2,52,1,19043,0],
  [48,2,57,3,57130,0],
  [48,2,60,4,76174,0],
  [48,2,61,3,57130,0],
  [48,2,73,2,38087,0],
  [48,3,19,12,228521,0],
  [48,3,34,1,19043,0],
  [48,3,43,1,19043,0],
  [48,3,45,9,171390,0],
  [48,3,79,1,19043,0],
  [48,4,82,1,19043,0],
  [49,0,0,28,533215,0],
  [49,0,4,9,171390,0],
  [49,0,6,13,247564,0],
  [49,0,9,5,95217,0],
  [49,0,10,10,190434,0],
  [49,0,14,3,57130,0],
  [49,0,17,5,95217,0],
  [49,0,20,8,152347,0],
  [49,0,21,10,190434,0],
  [49,0,28,3,57130,0],
  [49,0,38,16,304694,1],
  [49,0,47,5,95217,0],
  [49,0,53,1,19043,0],
  [49,0,56,4,76174,0],
  [49,0,70,8,152347,0],
  [49,1,5,8,152347,0],
  [49,1,7,6,114260,0],
  [49,1,11,8,152347,0],
  [49,1,12,4,76174,0],
  [49,1,15,3,57130,0],
  [49,1,18,5,95217,0],
  [49,1,25,2,38087,0],
  [49,1,33,5,95217,0],
  [49,1,40,2,38087,0],
  [49,1,55,3,57130,0],
  [49,2,2,8,152347,0],
  [49,2,3,15,285651,0],
  [49,2,8,7,133304,0],
  [49,2,13,7,133304,0],
  [49,2,44,4,76174,0],
  [49,2,46,2,38087,0],
  [49,2,49,2,38087,0],
  [49,2,50,5,95217,0],
  [49,2,52,2,38087,0],
  [49,2,57,6,114260,0],
  [49,2,58,2,38087,0],
  [49,2,61,2,38087,0],
  [49,2,64,2,38087,0],
  [49,2,75,1,19043,0],
  [49,3,19,6,114260,0],
  [49,3,34,1,19043,0],
  [49,3,43,1,19043,0],
  [49,3,90,1,19043,0],
];

/**
 * [weekIdx, dcIdx, endingInv, qtySold, qtyReceived, returned, demand]
 *
 * "returned" is returned-to-stock plus morgue, i.e. everything that came back
 * or became unsaleable. It is a distribution-centre measure, so it responds to
 * the wholesaler, location and region cuts but not to customer or class of
 * trade — those exist only on the 867 sales side.
 */
export type EmdInventoryFact = [number, number, number, number, number, number, number];
export const INVENTORY_FACTS: EmdInventoryFact[] = [
  [0,0,0,0,0,0,0],
  [0,1,1,1,0,0,11],
  [0,2,151,11,0,0,514],
  [0,3,1,2,0,0,23],
  [0,4,0,0,0,0,0],
  [0,5,360,111,120,0,2798],
  [0,6,217,70,69,0,2492],
  [0,7,101,29,48,0,0],
  [0,8,0,0,0,0,0],
  [0,9,2,0,0,0,1],
  [0,10,31,12,6,0,87],
  [0,11,0,0,0,0,0],
  [0,12,135,136,120,10,0],
  [0,13,48,1,4,0,66],
  [0,14,0,0,0,0,0],
  [1,0,0,0,0,0,0],
  [1,1,1,1,0,0,5],
  [1,2,116,37,96,0,1384],
  [1,3,2,1,2,0,20],
  [1,4,0,0,0,0,0],
  [1,5,266,77,72,0,2149],
  [1,6,185,46,0,0,1652],
  [1,7,68,25,24,0,0],
  [1,8,0,0,0,0,0],
  [1,9,2,0,0,0,1],
  [1,10,31,0,0,0,29],
  [1,11,0,0,0,0,0],
  [1,12,94,54,168,12,0],
  [1,13,44,1,0,0,83],
  [1,14,0,0,0,0,0],
  [2,0,0,0,0,0,0],
  [2,1,2,0,2,0,13],
  [2,2,213,59,96,0,1141],
  [2,3,3,0,1,0,14],
  [2,4,0,0,0,0,0],
  [2,5,278,122,192,0,2907],
  [2,6,185,30,0,0,1648],
  [2,7,95,24,48,0,0],
  [2,8,0,0,0,0,0],
  [2,9,2,0,0,0,1],
  [2,10,40,3,20,0,73],
  [2,11,0,0,0,0,0],
  [2,12,175,97,72,12,0],
  [2,13,40,13,15,0,116],
  [2,14,0,0,0,0,0],
  [3,0,0,0,0,0,0],
  [3,1,2,0,0,0,8],
  [3,2,158,26,0,0,1144],
  [3,3,3,0,0,0,11],
  [3,4,0,0,0,0,0],
  [3,5,371,16,168,0,1800],
  [3,6,132,15,0,0,832],
  [3,7,79,19,0,0,0],
  [3,8,0,0,0,0,0],
  [3,9,2,0,0,0,1],
  [3,10,37,6,3,0,58],
  [3,11,0,0,0,0,0],
  [3,12,217,53,0,8,0],
  [3,13,29,19,8,0,83],
  [3,14,0,0,0,0,0],
  [4,0,0,0,0,0,0],
  [4,1,2,0,0,0,8],
  [4,2,146,23,0,0,808],
  [4,3,2,1,0,0,25],
  [4,4,0,0,0,0,0],
  [4,5,242,107,0,0,2104],
  [4,6,151,32,0,0,836],
  [4,7,47,27,0,1,0],
  [4,8,0,0,0,0,0],
  [4,9,2,0,0,0,1],
  [4,10,30,0,0,0,58],
  [4,11,0,0,0,0,0],
  [4,12,218,54,96,6,0],
  [4,13,39,1,0,0,50],
  [4,14,0,0,0,0,0],
  [4,17,0,0,0,0,0],
  [5,0,0,0,0,0,0],
  [5,1,1,1,0,0,6],
  [5,2,95,48,0,0,1120],
  [5,3,0,2,0,0,10],
  [5,4,0,0,0,0,0],
  [5,5,263,59,192,0,1639],
  [5,6,246,63,121,0,1692],
  [5,7,32,15,0,0,0],
  [5,8,0,0,0,0,0],
  [5,9,2,0,0,0,0],
  [5,10,22,8,0,0,27],
  [5,11,0,0,0,0,0],
  [5,12,172,37,0,4,0],
  [5,13,29,8,0,0,77],
  [5,14,62,4,0,0,0],
  [5,17,0,0,0,0,0],
  [6,0,0,0,0,0,0],
  [6,1,3,0,0,0,6],
  [6,2,170,13,0,0,867],
  [6,3,3,0,3,0,14],
  [6,4,0,0,0,0,0],
  [6,5,296,0,0,0,1162],
  [6,6,205,59,95,0,848],
  [6,7,0,0,0,0,0],
  [6,8,0,0,0,0,0],
  [6,9,0,0,0,0,0],
  [6,10,26,13,11,0,40],
  [6,11,0,0,0,0,0],
  [6,12,189,16,0,6,0],
  [6,13,30,4,13,0,26],
  [6,14,87,17,0,0,0],
  [6,17,0,1,0,0,0],
  [7,0,0,0,0,0,0],
  [7,1,1,2,0,0,4],
  [7,2,176,61,72,0,1359],
  [7,3,2,0,0,0,7],
  [7,4,0,0,0,0,0],
  [7,5,355,54,144,0,2379],
  [7,6,90,72,0,0,1696],
  [7,7,0,0,0,0,0],
  [7,8,0,0,0,0,0],
  [7,9,0,0,0,0,0],
  [7,10,23,1,0,0,40],
  [7,11,0,0,0,0,0],
  [7,12,227,69,0,8,0],
  [7,13,30,7,7,0,64],
  [7,14,79,45,0,0,0],
  [7,17,0,0,0,0,0],
  [8,0,0,0,0,0,0],
  [8,1,3,0,2,0,11],
  [8,2,109,66,0,0,1444],
  [8,3,3,1,2,0,12],
  [8,4,0,0,0,0,0],
  [8,5,306,0,0,0,532],
  [8,6,166,20,124,1,1284],
  [8,7,0,0,0,0,0],
  [8,8,0,0,0,0,0],
  [8,9,0,0,0,0,0],
  [8,10,23,0,0,0,13],
  [8,11,0,0,0,0,0],
  [8,12,129,21,0,4,0],
  [8,13,27,0,0,0,51],
  [8,14,61,9,0,0,0],
  [8,17,1,0,0,0,0],
  [9,0,0,0,0,0,0],
  [9,1,3,0,0,0,2],
  [9,2,219,24,120,0,591],
  [9,3,4,0,1,0,14],
  [9,4,0,0,0,0,0],
  [9,5,240,85,0,0,1566],
  [9,6,232,74,0,0,2108],
  [9,7,0,0,0,0,0],
  [9,8,0,0,0,0,0],
  [9,9,0,0,0,0,0],
  [9,10,33,5,10,0,53],
  [9,11,0,0,0,0,0],
  [9,12,134,49,0,2,0],
  [9,13,12,11,0,0,8],
  [9,14,26,6,0,0,0],
  [9,17,0,0,0,0,17],
  [10,0,0,0,0,0,0],
  [10,1,3,0,0,0,5],
  [10,2,195,35,72,0,1287],
  [10,3,4,0,0,0,5],
  [10,4,0,0,0,0,0],
  [10,5,240,15,0,0,2273],
  [10,6,231,47,0,0,1268],
  [10,7,0,0,0,0,0],
  [10,8,0,0,0,0,0],
  [10,9,0,0,0,0,0],
  [10,10,33,10,6,0,52],
  [10,11,0,0,0,0,0],
  [10,12,197,99,144,0,0],
  [10,13,30,0,12,0,30],
  [10,14,11,15,0,0,0],
  [10,17,17,0,0,0,11],
  [11,0,0,0,0,0,0],
  [11,1,3,0,0,0,9],
  [11,2,172,33,0,0,889],
  [11,3,4,0,0,0,5],
  [11,4,0,0,0,0,0],
  [11,5,239,18,0,0,568],
  [11,6,229,65,0,0,1272],
  [11,7,0,0,0,0,0],
  [11,8,0,0,0,0,0],
  [11,9,0,0,0,0,0],
  [11,10,38,5,21,0,26],
  [11,11,0,0,0,0,0],
  [11,12,200,0,0,0,0],
  [11,13,28,1,0,0,20],
  [11,14,51,7,0,0,0],
  [11,17,4,1,0,0,17],
  [12,0,0,0,0,0,0],
  [12,1,0,0,0,0,2],
  [12,2,131,34,0,0,838],
  [12,3,3,1,1,0,29],
  [12,4,0,0,0,0,0],
  [12,5,369,78,216,0,3096],
  [12,6,156,34,0,0,1272],
  [12,7,0,0,0,0,0],
  [12,8,0,0,0,0,0],
  [12,9,0,0,0,0,0],
  [12,10,23,16,3,0,26],
  [12,11,0,0,0,0,0],
  [12,12,226,0,0,0,0],
  [12,13,28,0,0,0,29],
  [12,14,45,6,0,0,0],
  [12,17,16,0,12,0,28],
  [13,0,0,0,0,0,0],
  [13,1,4,0,0,0,12],
  [13,2,86,11,0,0,567],
  [13,3,4,0,0,0,14],
  [13,4,0,0,0,0,0],
  [13,5,346,48,0,0,1238],
  [13,6,261,26,0,0,1284],
  [13,7,0,0,0,0,0],
  [13,8,0,0,0,0,0],
  [13,9,0,0,0,0,0],
  [13,10,40,0,0,0,52],
  [13,11,0,0,0,0,0],
  [13,12,95,119,0,0,0],
  [13,13,26,0,0,0,10],
  [13,14,114,33,48,0,0],
  [13,17,18,9,0,0,22],
  [14,0,0,0,0,0,0],
  [14,1,4,1,0,0,12],
  [14,2,172,21,192,0,1206],
  [14,3,4,0,0,0,10],
  [14,4,0,0,0,0,0],
  [14,5,382,93,120,0,2477],
  [14,6,191,58,0,0,1276],
  [14,7,0,0,0,0,0],
  [14,8,0,0,0,0,0],
  [14,9,0,0,0,0,0],
  [14,10,40,0,0,0,13],
  [14,11,0,0,0,0,0],
  [14,12,213,26,144,0,0],
  [14,13,26,0,0,0,25],
  [14,14,92,34,48,0,0],
  [14,17,9,10,0,0,20],
  [15,0,0,0,0,0,0],
  [15,1,4,0,0,0,6],
  [15,2,148,22,0,0,844],
  [15,3,4,0,0,0,14],
  [15,4,0,0,0,0,0],
  [15,5,329,56,0,0,1238],
  [15,6,198,84,0,0,1272],
  [15,7,0,0,0,0,0],
  [15,8,0,0,0,0,0],
  [15,9,0,0,0,0,0],
  [15,10,32,1,16,0,26],
  [15,11,0,0,0,0,0],
  [15,12,261,62,144,0,0],
  [15,13,25,0,0,0,13],
  [15,14,91,49,24,0,0],
  [15,17,13,6,15,0,34],
  [16,0,0,0,0,0,0],
  [16,1,4,0,0,0,19],
  [16,2,205,34,48,0,1152],
  [16,3,2,1,0,0,10],
  [16,4,0,0,0,0,0],
  [16,5,369,35,0,0,1857],
  [16,6,225,47,130,0,1280],
  [16,7,0,0,0,0,0],
  [16,8,0,0,0,0,0],
  [16,9,0,0,0,0,0],
  [16,10,29,12,21,0,65],
  [16,11,0,0,0,0,0],
  [16,12,248,42,120,0,0],
  [16,13,23,1,0,0,25],
  [16,14,94,28,48,0,0],
  [16,17,19,1,22,0,14],
  [17,0,0,0,0,0,0],
  [17,1,4,0,0,0,16],
  [17,2,180,18,0,0,816],
  [17,4,0,0,0,0,0],
  [17,5,339,38,96,0,1238],
  [17,6,213,35,79,0,1284],
  [17,7,0,0,0,0,0],
  [17,8,0,0,0,0,0],
  [17,9,0,0,0,0,0],
  [17,10,31,6,9,0,52],
  [17,11,0,0,0,0,0],
  [17,12,259,0,0,0,0],
  [17,13,23,0,0,0,19],
  [17,14,118,18,0,0,0],
  [17,17,24,7,12,0,38],
  [18,0,0,0,0,0,0],
  [18,1,4,0,0,0,9],
  [18,2,152,28,0,0,554],
  [18,3,1,3,0,0,10],
  [18,4,0,0,0,0,0],
  [18,5,332,130,0,0,2625],
  [18,6,237,42,98,0,1696],
  [18,7,0,0,0,0,0],
  [18,8,0,0,0,0,0],
  [18,9,0,0,0,0,0],
  [18,10,40,7,16,0,38],
  [18,11,0,0,0,0,0],
  [18,12,252,55,0,0,0],
  [18,14,99,11,0,0,0],
  [18,17,13,15,4,0,57],
  [19,0,0,0,0,0,0],
  [19,1,2,0,0,0,3],
  [19,2,173,55,48,0,1478],
  [19,3,4,0,3,0,25],
  [19,4,0,0,0,0,0],
  [19,5,221,0,0,0,650],
  [19,6,189,34,0,0,840],
  [19,7,0,0,0,0,0],
  [19,8,0,0,0,0,0],
  [19,9,0,0,0,0,0],
  [19,10,32,2,0,0,38],
  [19,11,0,0,0,0,0],
  [19,12,252,70,0,0,0],
  [19,13,21,0,0,0,6],
  [19,14,93,9,0,0,0],
  [19,17,18,9,0,0,38],
  [20,0,0,0,0,0,0],
  [20,1,4,0,2,0,11],
  [20,2,188,45,96,0,1444],
  [20,3,4,0,0,0,5],
  [20,4,0,0,0,0,0],
  [20,5,283,134,216,0,2395],
  [20,6,227,40,144,0,1256],
  [20,7,0,0,0,0,0],
  [20,8,0,0,0,0,0],
  [20,9,0,0,0,0,0],
  [20,10,33,0,9,0,38],
  [20,11,0,0,0,0,0],
  [20,12,192,35,0,0,0],
  [20,13,21,0,0,0,17],
  [20,14,66,19,0,0,0],
  [20,17,19,0,0,0,19],
  [21,0,0,0,0,0,0],
  [21,1,4,0,0,0,3],
  [21,2,227,16,96,0,905],
  [21,3,4,0,0,0,20],
  [21,4,0,0,0,0,0],
  [21,5,356,51,168,0,2416],
  [21,6,247,21,111,0,848],
  [21,7,0,0,0,0,0],
  [21,8,0,0,0,0,0],
  [21,10,20,22,10,0,90],
  [21,11,0,0,0,0,0],
  [21,12,314,43,0,0,0],
  [21,13,21,0,0,0,11],
  [21,14,72,71,0,0,0],
  [21,17,20,0,0,0,10],
  [22,0,0,0,0,0,0],
  [22,1,4,0,0,0,8],
  [22,2,201,31,48,0,1113],
  [22,3,4,1,0,0,9],
  [22,4,0,0,0,0,0],
  [22,5,236,32,0,0,1644],
  [22,6,154,16,0,0,840],
  [22,7,0,0,0,0,0],
  [22,8,0,0,0,0,0],
  [22,9,0,0,0,0,0],
  [22,10,36,1,0,0,38],
  [22,11,0,0,0,0,0],
  [22,12,192,42,0,0,0],
  [22,13,21,0,0,0,8],
  [22,14,84,5,0,0,0],
  [22,17,12,12,0,0,54],
  [23,0,0,0,0,0,0],
  [23,1,3,0,0,0,3],
  [23,2,164,40,0,0,893],
  [23,3,4,0,0,0,17],
  [23,4,0,0,0,0,0],
  [23,5,236,1,0,0,1158],
  [23,6,183,83,138,0,1272],
  [23,7,0,0,0,0,0],
  [23,8,0,0,0,0,0],
  [23,9,0,0,0,0,0],
  [23,10,30,0,0,0,13],
  [23,11,0,0,0,0,0],
  [23,12,327,60,0,0,0],
  [23,13,21,0,0,0,4],
  [23,14,103,19,72,0,0],
  [23,17,8,4,10,0,33],
  [24,0,0,0,0,0,0],
  [24,1,2,1,0,0,10],
  [24,2,201,73,0,0,1747],
  [24,3,4,0,0,0,3],
  [24,4,0,0,0,0,0],
  [24,5,256,22,0,0,583],
  [24,6,107,74,0,0,1712],
  [24,7,0,0,0,0,0],
  [24,8,0,0,0,0,0],
  [24,9,0,0,0,0,0],
  [24,10,33,10,14,0,78],
  [24,11,0,0,0,0,0],
  [24,12,264,71,120,0,0],
  [24,13,8,11,0,0,5],
  [24,14,117,2,0,0,0],
  [24,17,16,2,0,0,11],
  [25,0,0,0,0,0,0],
  [25,1,2,0,0,0,7],
  [25,2,133,45,0,0,901],
  [25,3,4,0,0,0,10],
  [25,4,0,0,0,0,0],
  [25,5,304,29,0,0,1131],
  [25,6,88,28,0,0,432],
  [25,7,0,0,0,0,0],
  [25,8,0,0,0,0,0],
  [25,9,0,0,0,0,0],
  [25,10,35,1,10,0,39],
  [25,11,0,0,0,0,0],
  [25,12,275,28,0,0,0],
  [25,13,8,0,0,0,1],
  [25,14,51,90,24,0,0],
  [25,17,36,0,0,0,28],
  [26,0,0,0,0,0,0],
  [26,1,3,0,1,0,8],
  [26,2,157,4,0,0,615],
  [26,3,4,0,0,0,3],
  [26,4,0,0,0,0,0],
  [26,5,274,13,96,0,1070],
  [26,6,32,16,0,0,876],
  [26,7,0,0,0,0,0],
  [26,8,0,0,0,0,0],
  [26,9,0,0,0,0,0],
  [26,10,33,8,0,0,26],
  [26,11,0,0,0,0,0],
  [26,12,207,68,0,0,0],
  [26,13,0,10,6,0,9],
  [26,14,136,12,0,0,0],
  [26,17,34,0,0,0,14],
  [27,0,0,0,0,0,0],
  [27,1,2,1,0,0,5],
  [27,2,235,11,72,0,331],
  [27,3,3,0,3,0,17],
  [27,4,0,0,0,0,0],
  [27,5,262,104,120,0,2109],
  [27,6,95,19,0,0,444],
  [27,7,0,0,0,0,0],
  [27,8,0,0,0,0,0],
  [27,9,0,0,0,0,0],
  [27,10,39,0,0,0,46],
  [27,11,0,0,0,0,0],
  [27,12,253,0,0,0,0],
  [27,13,4,0,0,0,2],
  [27,14,122,26,0,0,0],
  [27,17,31,8,6,0,55],
  [28,0,0,0,0,0,0],
  [28,1,2,0,0,0,5],
  [28,2,197,33,48,0,1190],
  [28,3,4,0,2,0,10],
  [28,4,0,0,0,0,0],
  [28,5,219,91,0,0,2158],
  [28,6,113,130,152,0,3040],
  [28,7,0,0,0,0,0],
  [28,8,0,0,0,0,0],
  [28,9,0,0,0,0,0],
  [28,10,24,10,0,0,46],
  [28,11,0,0,0,0,0],
  [28,12,251,65,0,0,0],
  [28,14,125,8,0,0,0],
  [28,17,11,15,0,0,71],
  [29,0,0,0,0,0,0],
  [29,1,3,0,1,0,13],
  [29,2,158,20,0,0,626],
  [29,3,4,0,0,0,10],
  [29,4,0,0,0,0,0],
  [29,5,297,38,0,0,1739],
  [29,6,199,27,184,0,1216],
  [29,7,0,0,0,0,0],
  [29,8,0,0,0,0,0],
  [29,9,0,0,0,0,0],
  [29,10,18,6,0,0,23],
  [29,11,0,0,0,0,0],
  [29,12,285,34,0,0,0],
  [29,13,3,0,0,0,1],
  [29,14,106,36,24,0,0],
  [29,17,21,4,0,0,35],
  [30,0,0,0,0,0,0],
  [30,1,2,0,0,0,8],
  [30,2,204,21,48,0,588],
  [30,3,1,0,0,0,10],
  [30,4,0,0,0,0,0],
  [30,5,292,94,96,0,1643],
  [30,6,178,56,114,0,2352],
  [30,7,0,0,0,0,0],
  [30,8,0,0,0,0,0],
  [30,9,0,0,0,0,0],
  [30,10,41,4,0,0,41],
  [30,11,0,0,0,0,0],
  [30,12,288,69,120,0,0],
  [30,13,3,0,0,0,1],
  [30,14,98,19,48,0,0],
  [30,15,0,0,0,0,0],
  [30,17,17,0,0,0,24],
  [31,0,0,0,0,0,0],
  [31,1,3,0,1,0,7],
  [31,2,176,68,72,0,820],
  [31,3,1,1,2,0,13],
  [31,4,0,0,0,0,0],
  [31,5,261,53,120,0,2183],
  [31,6,194,33,0,0,2292],
  [31,7,0,0,0,0,0],
  [31,8,0,0,0,0,0],
  [31,9,0,0,0,0,0],
  [31,10,45,3,0,0,45],
  [31,11,0,0,0,0,0],
  [31,12,150,77,0,0,0],
  [31,13,3,0,0,0,3],
  [31,14,85,56,48,0,0],
  [31,15,0,0,0,0,0],
  [31,16,0,0,0,0,0],
  [31,17,23,6,0,0,24],
  [32,0,0,0,0,0,0],
  [32,1,4,0,2,0,3],
  [32,2,176,51,96,0,1204],
  [32,3,1,0,0,0,21],
  [32,4,0,0,0,0,0],
  [32,5,261,37,144,0,1651],
  [32,6,194,43,0,0,2128],
  [32,7,0,0,0,0,0],
  [32,8,0,0,0,0,0],
  [32,9,0,0,0,0,0],
  [32,10,45,3,0,0,45],
  [32,12,250,31,0,0,0],
  [32,13,3,0,0,0,1],
  [32,14,107,30,72,0,0],
  [32,16,0,0,0,0,0],
  [32,17,32,14,0,0,71],
  [33,0,0,0,0,0,0],
  [33,1,0,0,0,0,8],
  [33,2,166,27,0,0,917],
  [33,3,1,3,0,0,14],
  [33,4,0,0,0,0,0],
  [33,5,332,76,240,0,2371],
  [33,6,141,65,128,0,2080],
  [33,7,0,0,0,0,0],
  [33,8,0,0,0,0,0],
  [33,9,0,0,0,0,0],
  [33,10,38,2,16,0,45],
  [33,11,0,0,0,0,0],
  [33,12,240,14,168,0,0],
  [33,13,2,0,0,0,1],
  [33,14,107,8,0,0,0],
  [33,15,0,0,0,0,0],
  [33,16,0,0,0,0,0],
  [33,17,33,6,0,0,35],
  [34,0,0,0,0,0,0],
  [34,1,7,0,1,0,18],
  [34,2,174,11,0,0,293],
  [34,3,1,0,3,0,11],
  [34,4,0,0,0,0,0],
  [34,5,385,55,144,0,2878],
  [34,6,167,40,114,0,1560],
  [34,7,0,0,0,0,0],
  [34,8,0,0,0,0,0],
  [34,9,0,0,0,0,0],
  [34,10,35,5,8,0,60],
  [34,11,0,0,0,0,0],
  [34,12,270,105,0,0,0],
  [34,13,2,0,0,0,2],
  [34,14,114,41,48,0,0],
  [34,15,0,0,0,0,0],
  [34,16,0,0,0,0,0],
  [34,17,29,7,3,0,47],
  [35,0,0,0,0,0,0],
  [35,1,7,0,0,0,18],
  [35,2,193,46,120,0,1140],
  [35,3,2,0,2,0,14],
  [35,5,296,134,72,0,2131],
  [35,6,161,22,0,0,968],
  [35,7,0,0,0,0,0],
  [35,8,0,0,0,0,0],
  [35,9,0,0,0,0,0],
  [35,10,30,4,0,0,15],
  [35,11,0,0,0,0,0],
  [35,12,186,50,0,0,0],
  [35,13,2,0,0,0,1],
  [35,14,77,17,0,0,0],
  [35,15,0,0,0,0,0],
  [35,16,0,0,0,0,0],
  [35,17,27,5,5,0,47],
  [36,0,0,0,0,0,0],
  [36,1,7,0,0,0,18],
  [36,2,193,4,0,0,606],
  [36,3,1,1,0,0,7],
  [36,4,0,0,0,0,0],
  [36,5,246,91,0,0,2262],
  [36,6,160,48,0,0,1364],
  [36,7,0,0,0,0,0],
  [36,8,0,0,0,0,0],
  [36,9,0,0,0,0,0],
  [36,10,27,7,7,0,23],
  [36,11,0,0,0,0,0],
  [36,12,186,65,0,0,0],
  [36,13,2,0,0,0,0],
  [36,14,54,57,96,0,0],
  [36,15,0,0,0,0,0],
  [36,16,0,0,0,0,0],
  [36,17,21,6,0,0,46],
  [37,0,0,0,0,0,0],
  [37,1,8,0,0,0,12],
  [37,2,309,47,96,0,930],
  [37,3,6,0,3,0,8],
  [37,4,0,0,0,0,0],
  [37,5,392,95,120,0,2193],
  [37,6,102,92,0,0,2272],
  [37,7,0,0,0,0,0],
  [37,8,0,0,0,0,0],
  [37,10,20,0,0,0,23],
  [37,11,0,0,0,0,0],
  [37,12,267,77,168,0,0],
  [37,13,1,1,0,0,1],
  [37,14,95,44,48,0,0],
  [37,15,0,0,0,0,0],
  [37,16,0,0,0,0,0],
  [37,17,31,1,0,0,35],
  [38,0,0,0,0,0,0],
  [38,1,4,2,0,0,37],
  [38,2,236,9,0,0,609],
  [38,3,6,0,0,0,5],
  [38,4,0,0,0,0,0],
  [38,5,283,71,0,0,2228],
  [38,6,138,69,134,0,2424],
  [38,7,0,0,0,0,0],
  [38,8,0,0,0,0,0],
  [38,9,0,0,0,0,0],
  [38,10,29,5,15,0,35],
  [38,11,0,0,0,0,0],
  [38,12,270,39,0,0,0],
  [38,13,1,0,0,0,1],
  [38,14,119,24,48,0,0],
  [38,15,0,0,0,0,0],
  [38,16,0,0,0,0,0],
  [38,17,31,0,0,0,35],
  [39,0,0,0,0,0,0],
  [39,1,1,3,0,0,39],
  [39,2,200,69,0,0,1778],
  [39,3,4,0,0,0,2],
  [39,4,0,0,0,0,0],
  [39,5,283,48,0,0,2115],
  [39,6,129,49,0,0,1896],
  [39,7,0,0,0,0,0],
  [39,8,0,0,0,0,0],
  [39,10,13,0,0,0,25],
  [39,11,0,0,0,0,0],
  [39,12,240,30,0,0,0],
  [39,13,1,0,0,0,1],
  [39,14,69,4,0,0,0],
  [39,15,0,0,0,0,0],
  [39,16,0,0,0,0,0],
  [39,17,26,5,0,0,46],
  [40,0,0,0,0,0,0],
  [40,1,11,0,0,0,41],
  [40,2,271,32,168,0,1165],
  [40,3,2,2,0,0,6],
  [40,4,0,0,0,0,0],
  [40,5,406,17,336,0,1059],
  [40,6,230,15,210,0,912],
  [40,7,0,0,0,0,0],
  [40,8,0,0,0,0,0],
  [40,9,0,0,0,0,0],
  [40,10,39,2,0,0,50],
  [40,11,0,0,0,0,0],
  [40,12,45,28,0,3,0],
  [40,13,2,0,0,0,0],
  [40,14,72,40,72,0,0],
  [40,15,0,0,0,0,0],
  [40,16,0,0,0,0,0],
  [40,17,22,8,0,0,32],
  [41,0,0,0,0,0,0],
  [41,1,11,0,0,0,20],
  [41,2,265,0,0,0,289],
  [41,3,1,1,0,0,5],
  [41,4,0,0,0,0,0],
  [41,5,256,52,0,0,1022],
  [41,6,226,46,90,0,1680],
  [41,7,0,0,0,0,0],
  [41,8,0,0,0,0,0],
  [41,9,0,0,0,0,0],
  [41,10,39,9,9,0,55],
  [41,11,0,0,0,0,0],
  [41,12,186,103,0,3,0],
  [41,13,2,0,0,0,2],
  [41,14,113,4,0,0,0],
  [41,15,0,0,0,0,0],
  [41,16,0,0,0,0,0],
  [41,17,21,0,0,0,32],
  [42,0,0,0,0,0,0],
  [42,1,12,0,2,0,16],
  [42,2,225,14,0,0,882],
  [42,3,3,0,0,0,5],
  [42,4,0,0,0,0,0],
  [42,5,326,88,96,0,2034],
  [42,6,141,24,0,0,404],
  [42,7,0,0,0,0,0],
  [42,8,0,0,0,0,0],
  [42,9,0,0,0,0,0],
  [42,10,20,0,0,0,14],
  [42,11,0,0,0,0,0],
  [42,12,186,0,0,1,0],
  [42,13,1,0,0,0,1],
  [42,15,0,0,0,0,0],
  [42,16,0,0,0,0,0],
  [42,17,21,0,0,0,32],
  [43,0,0,0,0,0,0],
  [43,1,12,0,0,0,31],
  [43,2,167,36,0,0,842],
  [43,3,3,0,0,0,7],
  [43,4,0,0,0,0,0],
  [43,5,271,37,0,0,518],
  [43,6,205,5,0,0,404],
  [43,7,0,0,0,0,0],
  [43,8,0,0,0,0,0],
  [43,9,0,0,0,0,0],
  [43,10,30,10,21,0,55],
  [43,11,0,0,0,0,0],
  [43,13,1,0,0,0,1],
  [43,14,81,4,0,0,0],
  [43,15,0,0,0,0,0],
  [43,16,0,0,0,0,0],
  [43,17,31,0,0,0,53],
  [44,0,0,0,0,0,0],
  [44,1,12,0,0,0,30],
  [44,2,172,27,0,0,541],
  [44,3,3,0,0,0,7],
  [44,4,0,0,0,0,0],
  [44,5,233,28,96,0,1484],
  [44,6,186,30,0,0,744],
  [44,7,0,0,0,0,0],
  [44,8,0,0,0,0,0],
  [44,9,0,0,0,0,0],
  [44,10,26,3,0,0,41],
  [44,11,0,0,0,0,0],
  [44,12,208,103,0,4,0],
  [44,13,1,0,0,0,2],
  [44,14,134,8,72,0,0],
  [44,15,0,0,0,0,0],
  [44,16,0,0,0,0,0],
  [44,17,29,2,0,0,21],
  [45,0,0,0,0,0,0],
  [45,1,12,0,0,0,25],
  [45,2,136,63,0,0,1479],
  [45,3,0,3,0,0,7],
  [45,4,0,0,0,0,0],
  [45,5,172,104,144,0,2520],
  [45,6,191,46,96,0,1152],
  [45,7,0,0,0,0,0],
  [45,8,0,0,0,0,0],
  [45,9,0,0,0,0,0],
  [45,10,26,1,13,0,44],
  [45,11,0,0,0,0,0],
  [45,12,208,108,0,5,0],
  [45,13,1,0,1,0,2],
  [45,14,98,67,0,0,0],
  [45,15,0,0,0,0,0],
  [45,16,0,0,0,0,0],
  [45,17,29,2,17,0,39],
  [46,0,0,0,0,0,0],
  [46,1,11,1,0,0,25],
  [46,2,133,67,0,0,2036],
  [46,3,3,0,3,0,19],
  [46,4,0,0,0,0,0],
  [46,5,236,116,120,0,3132],
  [46,6,188,101,96,0,2664],
  [46,7,0,0,0,0,0],
  [46,8,0,0,0,0,0],
  [46,9,0,0,0,0,0],
  [46,10,24,16,7,0,77],
  [46,11,0,0,0,0,0],
  [46,12,253,86,144,6,0],
  [46,13,2,0,0,0,2],
  [46,14,116,52,120,0,0],
  [46,15,0,0,0,0,0],
  [46,16,0,0,0,0,0],
  [46,17,24,9,4,0,69],
  [47,0,0,0,0,0,0],
  [47,1,11,0,0,0,33],
  [47,2,213,40,120,0,1996],
  [47,3,1,2,0,0,19],
  [47,4,0,0,0,0,0],
  [47,5,228,152,144,0,3651],
  [47,6,199,85,100,0,2660],
  [47,7,0,0,0,0,0],
  [47,8,0,0,0,0,0],
  [47,9,0,0,0,0,0],
  [47,10,24,13,13,0,77],
  [47,11,0,0,0,0,0],
  [47,12,174,127,48,7,0],
  [47,13,1,1,0,0,2],
  [47,14,50,66,0,0,0],
  [47,15,0,0,0,0,0],
  [47,16,0,0,0,0,0],
  [47,17,28,3,7,0,69],
  [48,0,0,0,0,0,0],
  [48,1,10,1,0,0,38],
  [48,2,180,81,48,0,1777],
  [48,3,2,1,2,0,19],
  [48,4,0,0,0,0,0],
  [48,5,258,138,168,0,3802],
  [48,6,214,83,95,0,2660],
  [48,7,0,0,0,0,0],
  [48,8,0,0,0,0,0],
  [48,9,0,0,0,0,0],
  [48,10,23,15,14,0,77],
  [48,11,0,0,0,0,0],
  [48,12,252,138,216,7,0],
  [48,13,1,0,0,0,2],
  [48,14,111,59,120,0,0],
  [48,15,0,0,0,0,0],
  [48,16,0,0,0,0,0],
  [48,17,24,14,10,0,69],
  [49,0,0,0,0,0,0],
  [49,1,10,0,0,0,47],
  [49,2,168,76,96,0,1900],
  [49,3,2,0,1,0,33],
  [49,4,0,0,0,0,0],
  [49,5,194,142,144,0,3817],
  [49,6,186,114,65,0,2588],
  [49,7,0,0,0,0,0],
  [49,8,0,0,0,0,0],
  [49,9,0,0,0,0,0],
  [49,10,23,8,11,0,83],
  [49,11,0,0,0,0,0],
  [49,12,224,132,120,7,0],
  [49,13,1,0,0,0,2],
  [49,14,105,44,48,0,0],
  [49,15,0,0,0,0,0],
  [49,16,0,0,0,0,0],
  [49,17,24,7,2,0,62],
  [50,0,0,0,0,0,0],
  [50,1,9,1,0,0,47],
  [50,2,193,55,48,0,1964],
  [50,3,5,1,3,0,43],
  [50,4,0,0,0,0,0],
  [50,5,236,171,144,0,3850],
  [50,6,183,112,128,0,2672],
  [50,7,0,0,0,0,0],
  [50,8,0,0,0,0,0],
  [50,9,0,0,0,0,0],
  [50,10,21,17,12,0,83],
  [50,11,0,0,0,0,0],
  [50,12,268,140,168,7,0],
  [50,13,1,0,0,0,2],
  [50,14,100,63,48,0,0],
  [50,15,0,0,0,0,0],
  [50,16,0,0,0,0,0],
  [50,17,17,9,7,0,62],
  [51,0,0,0,0,0,0],
  [51,1,9,0,0,0,34],
  [51,2,205,36,48,0,1598],
  [51,3,3,2,0,0,33],
  [51,4,0,0,0,0,0],
  [51,5,286,142,192,0,3495],
  [51,6,185,80,110,0,2344],
  [51,7,0,0,0,0,0],
  [51,8,0,0,0,0,0],
  [51,9,0,0,0,0,0],
  [51,10,30,9,18,0,71],
  [51,11,0,0,0,0,0],
  [51,12,134,134,0,6,0],
  [51,13,1,0,0,0,2],
  [51,14,19,81,0,0,0],
  [51,15,0,0,0,0,0],
  [51,16,0,0,0,0,0],
  [51,17,14,3,0,0,53],
];
